<template>
  <div :style="is_full ? 'margin: 30px 0' : ''">
    <div v-if="is_full" style="display: flex; align-items: center">
      <el-button size="mini" @click="m__back_to_list">
        <strong><i style="font-weight: bold" class="el-icon-arrow-left"></i> {{ $t('base.back') }}</strong>
      </el-button>

      <div style="display: flex; margin-left: 20px; gap: 40px; align-items: center">
        <div style="font-size: 15px!important;">
          {{ $t('base.product_campaign_detail') }}
          &nbsp;-&nbsp; Campaign ID:
          <strong style="font-size: 15px; cursor: pointer" class="text-primary"
                  @click="copy_text(parent_campaign && parent_campaign.campaign ? parent_campaign.campaign.campaignid : '' )">
            {{ parent_campaign && parent_campaign.campaign && parent_campaign.campaign.campaignid }}
          </strong>

          &nbsp;-&nbsp; Product ID:
          <strong style="font-size: 15px; cursor: pointer" class="text-primary"
                  @click="copy_text(parent_campaign && parent_campaign.product ? parent_campaign.product.itemid : '' )">
            {{ parent_campaign && parent_campaign.product && parent_campaign.product.itemid }}
          </strong>

          &nbsp;-&nbsp; {{ $t('base.placement') }}:
          <el-popover
            placement="bottom"
            width="200"
            trigger="click"
            @click.native="product_placement_radio = product_placement_radio_display">
            <div style="font-size: 13px; margin-bottom: 20px">
              {{ $t('base.edit') }} {{ $t('base.placement') }}
            </div>
            <div style="display: flex; flex-direction: column; gap: 10px">
              <el-radio v-model="product_placement_radio" label="all">{{ $t('base.all') }}</el-radio>
              <el-radio v-model="product_placement_radio" label="search_product">{{ $t('base.search') }}</el-radio>
              <el-radio v-model="product_placement_radio" label="targeting">{{ $t('base.discovery') }}</el-radio>

              <div class="text-right" style="margin-top: 5px">
                <el-button type="primary" size="mini" @click="m__change_product_placement">{{
                    $t('base.confirm')
                  }}
                </el-button>
              </div>
            </div>
            <strong slot="reference" style="font-size: 15px; cursor: pointer" class="text-primary">
              <template v-if="product_placement_radio_display === 'all'">{{ $t('base.all') }}</template>
              <template v-if="product_placement_radio_display === 'search_product'">{{ $t('base.search') }}</template>
              <template v-if="product_placement_radio_display === 'targeting'">{{ $t('base.discovery') }}</template>
            </strong>
          </el-popover>
        </div>

        <div>
          <slot name="automatic_configuration"></slot>
        </div>
      </div>
    </div>

    <el-row v-if="is_full" style="margin: 10px 0; margin-top: 30px">
      <el-col :sm="18" class="cut-text" style="padding-left: 5px">
        <table class="table">
          <tr>
            <td style="vertical-align: middle !important; width: 110px">
              <strong v-if="campaign.campaign.state === 'ongoing'"
                      class="text-success">[{{ $t('base.ongoing').toUpperCase() }}]</strong>
              <strong v-if="campaign.campaign.state === 'paused'"
                      class="text-warning">[{{ $t('base.paused').toUpperCase() }}]</strong>
              <strong v-if="campaign.campaign.state === 'ended'" class="text-danger">[{{
                  $t('base.ended').toUpperCase()
                }}]</strong>
              <strong v-if="campaign.campaign.state === 'deleted'" class="text-danger">[{{
                  $t('base.deleted')
                }}]</strong>
            </td>
            <td style="vertical-align: middle !important;">
              &nbsp;
              &nbsp;
              <span style="font-size: 13px">{{ $t('base.product') }}:</span>
              <a href="javascript:void(0)"
                 @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${parent_campaign.product.itemid}`, shop)"
                 style="font-size: 13px">{{ campaign.product.name }}</a>
            </td>
          </tr>
          <tr>
            <td></td>
            <td style="padding-top: 5px; color: #666;">
              &nbsp;
              &nbsp;
              <span style="font-size: 13px">{{ $t('base.duration') }}: </span>
              &nbsp;
              <a style="color: #666; font-size: 13px" href="javascript:void(0)"
                 @click="m__show_update_campaign_date">
                <template v-if="campaign.campaign.end_time === 0"> {{ $t('base.no_end_date') }}</template>
                <template v-else>
                  {{ campaign.campaign.start_time * 1000 | moment('DD/MM/YYYY') }}
                  -
                  {{ campaign.campaign.end_time * 1000 | moment('DD/MM/YYYY') }}
                </template>
                <i class="el-icon-edit"></i></a>
              &nbsp;
              &nbsp;
              &nbsp;
              &nbsp;
              <span style="font-size: 13px">{{ $t('base.budget') }}:</span>
              &nbsp;
              <a style="color: #666; font-size: 13px" href="javascript:void(0)"
                 @click="m__show_update_campaign_quota">
                <template
                  v-if="m__calculate(campaign.campaign.daily_quota) === 0 && m__calculate(campaign.campaign.total_quota) === 0">
                  {{ $t('base.unlimited') }}
                </template>
                <template v-else-if="m__calculate(campaign.campaign.daily_quota)">
                  {{ campaign.campaign.daily_quota | currency }} {{ m__currency() }} ({{ $t('base.daily_budget') }})
                </template>
                <template v-else>
                  {{ campaign.campaign.total_quota | currency }} {{ m__currency() }} ({{ $t('base.total_budget') }})
                </template>
                <i class="el-icon-edit"></i>
              </a>
              &nbsp;
              &nbsp;
              &nbsp;
              &nbsp;
              <template v-if="m__has_pricing_type()">
                <a style="color: #666; font-size: 13px" href="javascript:void(0)"
                   @click="m__show_update_pricing_type">
                  {{ $t('base.shopee_advanced_settings') }}:&nbsp;
                  <strong v-if="m__get_pricing_type() === 1" class="text-danger"
                          style="font-size: 13px">{{ $t('base.turning_off') }}</strong>
                  <strong v-if="m__get_pricing_type() === 2" class="text-success"
                          style="font-size: 13px">{{ $t('base.turning_on') }}</strong>
                </a>
              </template>
              &nbsp;
              &nbsp;
              &nbsp;
              <template v-if="m__has_target_broad_roi()">
                <span style="font-size: 13px">{{ $t('base.target_roas') }}:</span>
                &nbsp;
                <a style="color: #666; font-size: 13px" href="javascript:void(0)"
                   @click="m__show_update_target_broad_roi_dialog">
                  {{ m__get_target_broad_roi() }}
                  <i class="el-icon-edit"></i>
                </a>
              </template>
            </td>
          </tr>
        </table>
      </el-col>
      <el-col :sm="6" class="text-right">
        <div v-if="campaign.campaign.state !== 'deleted'">
          <el-button v-if="campaign.campaign.state === 'ongoing'" size="mini" icon="el-icon-video-pause" type="warning"
                     @click="m__pause_campaign" plain>{{ $t('base.pause') }}
          </el-button>
          <el-button v-if="campaign.campaign.state === 'paused'" size="mini" icon="el-icon-refresh-right" type="success"
                     @click="m__ongoing_campaign" plain>{{ $t('base.resume') }}
          </el-button>
          <el-button v-if="campaign.campaign.state === 'ongoing' || campaign.campaign.state === 'paused'" size="mini"
                     icon="el-icon-circle-close" type="danger" plain @click="m__stop_campaign">{{ $t('base.stop') }}
          </el-button>
          <el-button v-if="campaign.campaign.state === 'ended'" size="mini" icon="el-icon-refresh-right" type="success"
                     @click="m__restart_campaign" plain>{{ $t('base.restart') }}
          </el-button>
          <el-button size="mini" icon="el-icon-delete" type="danger"
                     @click="m__delete_campaign" plain> {{ $t('base.delete') }}
          </el-button>
        </div>
      </el-col>
    </el-row>

    <div v-if="is_full && expected_cir" style="margin: 20px 0; display: flex">
      <div v-if="metrics.broad_cir &&  metrics.broad_cir <= expected_cir"
           style="flex: 1; padding: 15px 15px; border-radius: 5px; margin-right: 5px; background-color: #5c7">
        <div style="font-size: 14px; color: #fff; font-weight: bold">
          <i style="font-size: 14px; color: #fff"></i>
          {{ $t('ads.campaign_is_good') }}
        </div>
      </div>
      <div v-else
           style="flex: 1; padding: 15px 15px; border-radius: 5px; margin-right: 5px; background-color: #f56c6c">
        <div style="font-size: 14px; color: #fff; font-weight: bold">
          <i class="el-icon-warning-outline" style="font-size: 14px; color: #fff"></i>
          {{ $t('ads.campaign_is_not_good') }}
        </div>
      </div>
    </div>

    <div v-if="is_full && show_banner_duplicate" style="margin: 10px 0">
      <div
        style="display: flex; background-color: #ecf5ff; border-color: #d9ecff; padding: 10px; border-radius: 4px; font-weight: bold">
        <div style="flex: auto">
          <i class="el-icon-info"></i>
          {{ $t('ads.there_are_multiple_ongoing_message') }}
          <a href="javascript:void(0)" @click="m__open_duplicate_link">
            {{ $t('ads.there_are_multiple_ongoing_see_detail') }}
          </a>
        </div>
        <div style="width: 20px; display: flex; justify-content: right">
          <i class="el-icon-close" style="font-size: 13px !important; cursor: pointer"
             @click="show_banner_duplicate = false"></i>
        </div>
      </div>
    </div>

    <div v-if="is_full" style="margin-top: 20px">
      <ComponentMetric :metrics="metrics" :reports="reports" :is_compare="is_compare_keyword" :show_checkout="true"
                       :compare_metrics="compare_metrics" :compare_reports="compare_reports"
                       :shop="shop"></ComponentMetric>
    </div>
    <br v-if="is_full">
    <br v-if="is_full">

    <el-row v-if="is_full">
      <el-col :sm="4">
        &nbsp;
      </el-col>
      <el-col :sm="20" class="text-right">
        &nbsp;
        <template
          v-if="['vuducminhdev07', 'curravn@gmail.com', 'atoxon@atosa.asia', 'demo.sale@atosa.asia', 'ads.atosa14@gmail.com'].includes($store.state.userInfo.username)">
          <!--          <el-button type="primary" size="mini" @click="m__show_openai_dialog" icon="el-icon-s-marketing">
                      Chat GPT
                    </el-button>-->
        </template>
        &nbsp;&nbsp;
        <el-dropdown v-if="m__check_marketing_package('auto_campaign')" trigger="click"
                     @command="m__handle_bulk_configuration">
          <el-button type="info" size="mini" icon="el-icon-s-tools"
                     :disabled="!c__advertisement_list.filter(i => i.checked).length">
            <span class="text-danger"> {{ $t('ads.automatic_configuration') }} </span>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="auto">
              {{ $t('ads.mass_setup_auto_configuration') }}
            </el-dropdown-item>
            <el-dropdown-item command="anti">
              {{ $t('ads.mass_setup_anti_click_configuration') }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        &nbsp;&nbsp;
        <el-dropdown v-if="m__check_marketing_package('auto_campaign')" trigger="click"
                     @command="m__handle_on_off_remove_bulk_configuration">
          <el-button size="mini" type="info" :disabled="!c__advertisement_list.filter(i => i.checked).length">
            {{ $t('ads.resume_pause_delete_configuration') }}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="start_auto"> {{ $t('ads.resume') }} {{
                $t('ads.auto_configuration')
              }}
            </el-dropdown-item>
            <el-dropdown-item command="start_anti_click"> {{ $t('ads.resume') }} {{
                $t('ads.anti_click_configuration')
              }}
            </el-dropdown-item>
            <div class="hr" style="padding: 0 10px"></div>

            <el-dropdown-item command="stop_auto"> {{ $t('ads.pause') }} {{
                $t('ads.auto_configuration')
              }}
            </el-dropdown-item>
            <el-dropdown-item command="stop_anti_click"> {{ $t('ads.pause') }} {{
                $t('ads.anti_click_configuration')
              }}
            </el-dropdown-item>
            <div class="hr" style="padding: 0 10px"></div>

            <el-dropdown-item command="auto">
              {{ $t('ads.mass_delete_auto_configuration') }}
            </el-dropdown-item>
            <el-dropdown-item command="anti">
              {{ $t('ads.mass_delete_anti_click_configuration') }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        &nbsp;&nbsp;
        <el-button size="mini" @click="m__show_compare_keyword">
          {{ $t('base.compare_data') }}
          <strong style="font-weight: 600" v-if="is_compare_keyword" class="text-success">[ ON ]</strong>
          <strong style="font-weight: 700" v-else class="text-danger">[ OFF ]</strong>
        </el-button>
        <el-button size="mini" @click="show_dialog.operation_history = true" icon="el-icon-tickets">
          {{ $t('ads.operation_history') }}
        </el-button>
        &nbsp;&nbsp;
        <el-dropdown @command="m__handle_dropdown">
          <el-button size="mini" icon="el-icon-arrow-down" :loading="loading.export_report">{{
              $t('base.download_excel')
            }}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">
              {{
                $t('base.download_x_file', {x: $t('base.shopee_report')})
              }}
            </el-dropdown-item>
            <el-dropdown-item command="4">
              {{ $t('base.download_x_file', {x: $t('base.ad_metrics')}) }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        &nbsp;&nbsp;
        <el-button size="mini" @click="m__toggle_select_index">
          <i :class="show_dialog.select_index ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
          {{ $t('ads.select_metrics') }}
        </el-button>
      </el-col>
    </el-row>
    <br>

    <div v-if="is_full && show_dialog.select_index"
         style="border: 1px solid #e5e5e5;border-radius: 4px; padding: 20px 10px 10px 10px">
      <div style="width: 20%; float: left; margin-bottom: 10px; font-size: 13px" v-for="flag in c__flag_list"
           :key="flag.value">
        <el-checkbox size="mini" v-model="flag.checked" @change="m__update_flag_list" class="cbx-black"
                     :disabled="flag.checked === true && c__flag_list.filter(i => i.checked === true).length <= 1">
          &nbsp;{{ flag.label }}
        </el-checkbox>
      </div>
      <div style="clear: both!important;"></div>

      <br>

      <div v-for="flag in atosa_flag_list" :key="flag.value"
           style="width: 20%; float: left; margin-bottom: 10px; font-size: 13px">
        <el-checkbox size="mini" v-model="flag.checked" @change="m__set_atosa_flag_list" class="cbx-black">
          &nbsp;{{ flag.label }}
        </el-checkbox>
      </div>
      <div style="clear: both!important;"></div>
    </div>

    <br v-if="is_full">
    <div style="margin-bottom: 20px">
      <el-table id="main-table-detail" ref="main-table-detail" :data="c__advertisement_list"
                v-loading="parent_campaign.loading" :row-style="m__style_for_summary">
        <el-table-column fixed="left" width="40px">
          <template slot="header" slot-scope="scope">
            <el-checkbox
              v-if="c__advertisement_list.some(i => [1,2,5].includes(i.placement))"
              size="mini" :value="m__get_advertisement_list_checked_value()"
              @change="m__change_advertisement_list_checked_value">
            </el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox v-if="[1,2,5].includes(scope.row.placement)" size="mini"
                         v-model="scope.row.checked"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.placement')" :width="is_full ? '250px' : '404px'" fixed="left"
                         prop="placement">
          <template slot="header" slot-scope="scope">
            {{ $t('base.placement') }} &nbsp;-&nbsp; <i class="el-icon-refresh text-primary"></i>
            <a href="javascript:void(0)"
               class="text-primary"
               @click="m__load_campaign_detail(true)"> {{ $t('base.reload_data') }} </a>
          </template>
          <template slot-scope="scope">
            <div style="padding: 5px 0">
              <div v-if="scope.row.placement === 2">
                {{ $t('base.daily_discover') }}
                <div style="height: 5px"></div>
              </div>
              <div v-if="scope.row.placement === 5">
                {{ $t('base.you_may_also_like') }}
                <div style="height: 5px"></div>
              </div>
              <div v-if="scope.row.placement === 8">
                <div style="height: 5px"></div>
                {{ $t('ads.auto_bidding') }}
                <div style="height: 15px"></div>
              </div>
            </div>

            <div style="display: flex; gap: 10px">
              <div v-if="scope.row.auto_position"
                   :class="m__check_config_status(scope.row.auto_position) ? 'text-running' : 'text-paused'"
                   style="padding: 0 5px" @click="m__show_config_auto_campaign(scope.row)">
                <a href="javascript:void(0)">{{ $t('ads.auto_position') }}</a></div>

              <div v-if="scope.row.anti_click"
                   :class="m__check_config_status(scope.row.anti_click) ? 'text-running' : 'text-paused'"
                   style="padding: 0 5px" @click="m__show_config_anti_click_single(scope.row)">
                <a href="javascript:void(0)">{{ $t('ads.anti_click') }}</a></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.bid_price')" width="120px" fixed="left" prop="extinfo.target.price">
          <template slot-scope="scope">
            <template v-if="scope.row.placement !== 8">
              <div v-if="scope.row && scope.row.extinfo">
                <el-popover
                  placement="top"
                  width="300"
                  :ref="`popover-ads-` + scope.$index"
                  :disabled="scope.row.status !== 1"
                  @click.native="updated_base_price = scope.row.extinfo.target.price">
                  <div>
                    <strong class="strong-label">
                      {{ $t('base.bid_price_per_click') }}
                      ({{ $t('base.min') }} {{ TARGETING_MIN }}):
                    </strong>
                    <el-input v-model="updated_base_price" type="number" size="mini" :min="TARGETING_MIN"></el-input>
                  </div>
                  <div style="margin-top: 20px" class="text-right">
                    <el-button type="primary" size="mini" icon="el-icon-check"
                               @click="m__confirm_update_base_price(scope.row, scope.$index)">
                      {{ $t('base.confirm') }}
                    </el-button>
                  </div>

                  <el-button slot="reference" type="text" size="mini"
                             @click="scope.row.extinfo.target.show_popover = true">
                    {{ scope.row.extinfo.target.price | currency }}
                    &nbsp;
                    <i class="el-icon-edit-outline" style="font-size: 13px"></i>
                  </el-button>
                </el-popover>

                <div style="margin-top: 0">
                  <span class="text-grey">{{ $t('ads.suggested') }}: </span>
                  <span class="text-primary">
                    {{ scope.row.extinfo.target.recommended_price | currency }}
                  </span>
                </div>
              </div>
            </template>
            <template v-else>
              {{ $t('create_ads.auto_bidding') }}
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.status')" width="80px" fixed="left">
          <template slot-scope="scope">
            <el-switch
              v-if="scope.row.placement !== 8 && !scope.row.summary"
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#b7b7b7"
              :active-value="1"
              :inactive-value="3"
              :disabled="scope.row.status === 1 && advertisement_list.filter(i => i.status === 1).length <= 1"
              @change="m__change_ads_status(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column v-if="m__check_marketing_package('auto_campaign')" :label="$t('base.action')" width="140px">
          <template slot-scope="scope">
            <template v-if="scope.row.placement !== 8 && !scope.row.summary">
              <el-dropdown trigger="click"
                           @command="(command) => {if (command==='auto')m__show_config_auto_campaign(scope.row); if (command==='anti') m__show_config_anti_click_single(scope.row); if (command==='optimize') m__show_config_auto_optimize(scope.row)}">
                <el-button type="info" size="mini" icon="el-icon-s-tools">
                  <span class="text-danger">{{ $t('base.setup') }}</span>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="auto">
                    {{ $t('ads.auto_position') }} <br>
                    <span v-if="scope.row.config_auto || scope.row.auto_position" class="text-running"><a
                      href="javascript:void(0)">{{ $t('base.installed') }}</a></span>
                    <span v-else class="text-close"><a href="javascript:void(0)">{{
                        $t('base.not_installed')
                      }}</a></span>
                  </el-dropdown-item>

                  <div class="hr" style="padding: 0 5px"></div>
                  <el-dropdown-item command="anti">
                    {{ $t('ads.anti_click') }} <br>
                    <span v-if="scope.row.anti_click" class="text-running"><a
                      href="javascript:void(0)">{{ $t('base.installed') }}</a></span>
                    <span v-else class="text-close"><a href="javascript:void(0)">{{
                        $t('base.not_installed')
                      }}</a></span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="show_tags" width="140px" :label="$t('base.add_tags')" show-tooltip-when-overflow>
          <template slot="header" slot-scope="scope">
            <el-dropdown trigger="click" @command="m__handle_tag_command">
              <el-button type="text" size="mini">
                <strong :class="{'text-primary': tag_ids_selected.length}">
                  {{ $t('base.select_tags') }}
                  <i :class="show_dialog.select_index ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
                </strong>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="tag in keyword_tag_list" :key="tag._id" :command="tag._id">
                  <div style="display: flex; gap: 10px">
                    <span style="flex: auto">{{ tag.name }}</span>
                    <span style="width: 10px">
                      <i v-if="m__check_tag_ids_selected(tag._id)" class="el-icon-check"></i>
                    </span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="create_tag" divided>
                  <i class="el-icon-plus"></i> {{ $t('base.create_tags') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <template v-if="!scope.row.auto && !scope.row.summary && keyword_tag_list.length">
              <el-dropdown trigger="click" @command="m__handle_keyword_tag_command">
                <template v-if="m__map_keyword_tag(scope.row)">
                  <strong class="text-primary">{{ m__map_keyword_tag(scope.row) }}</strong>
                </template>
                <template v-else>
                  <strong style="color: #3d3d3d">{{ $t('base.add_tags') }}</strong>
                </template>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="tag in keyword_tag_list" :key="tag._id"
                                    :command="JSON.stringify({keyword:scope.row, tag_id: tag._id})">
                    <div style="display: flex; gap: 10px">
                      <span style="flex: auto">{{ tag.name }}</span>
                      <span style="width: 10px">
                        <i v-if="m__check_keyword_match(scope.row, tag._id)" class="el-icon-check"></i>
                      </span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="m__map_keyword_tag(scope.row)"
                                    :command="JSON.stringify({keyword:scope.row, tag_id: 'remove_tag'})" divided>
                    <i class="el-icon-close"></i> {{ $t('base.remove_tags') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.average_ranking')" width="120px" prop="report.average"
                         v-if="m__is_show_index('avg_rank')" sortable="custom">
          <template slot-scope="scope">
            <template v-if="scope.row.auto">-</template>
            <template v-else-if="scope.row.summary">-</template>
            <template v-else>
              {{ scope.row.report ? scope.row.report.avg_rank : 0 | currency }}

              <div v-if="is_compare_keyword" class="compare-keyword">
                {{ scope.row.c_report ? scope.row.c_report.avg_rank : 0 | currency }}
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.impressions')" width="120px" prop="report.impression"
                         v-if="m__is_show_index('impression')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.impression : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.impression : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.clicks')" width="120px" prop="report.click"
                         v-if="m__is_show_index('click')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.click : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.click : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="CPC" width="120px" prop="report.atosa_cpc"
                         v-if="m__is_show_index('click')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.atosa_cpc : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.atosa_cpc : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.ctr')" width="100px" prop="report.ctr"
                         v-if="m__is_show_index('ctr')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.ctr) * 100).toFixed(1) : '0.0' }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.ctr) * 100).toFixed(1) : '0.0' }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.conversions')" width="140px" prop="report.broad_order"
                         v-if="m__is_show_index('broad_order')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.broad_order : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.broad_order : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_conversions')" width="115px" prop="report.direct_order"
                         v-if="m__is_show_index('direct_order')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.direct_order : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.direct_order : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.items_sold')" width="150px" prop="report.broad_order_amount"
                         v-if="m__is_show_index('broad_order_amount')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.broad_order_amount : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.broad_order_amount : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_items_sold')" width="125px" prop="report.direct_order_amount"
                         v-if="m__is_show_index('direct_order_amount')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? scope.row.report.direct_order_amount : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? scope.row.c_report.direct_order_amount : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="GMV" width="120px" prop="report.broad_gmv"
                         v-if="m__is_show_index('broad_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.broad_gmv) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.broad_gmv) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_gmv')" width="130px" prop="report.direct_gmv"
                         v-if="m__is_show_index('direct_gmv')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.direct_gmv) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.direct_gmv) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.expense')" width="100px" prop="report.cost"
                         v-if="m__is_show_index('cost')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cost) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cost) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="ROI (ROAS)" width="120px" prop="report.broad_roi"
                         v-if="m__is_show_index('broad_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? parseFloat(scope.row.report.broad_roi).toFixed(2) : 0 }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? parseFloat(scope.row.c_report.broad_roi).toFixed(2) : 0 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_roi')" width="120px" prop="report.direct_roi"
                         v-if="m__is_show_index('direct_roi')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? parseFloat(scope.row.report.direct_roi).toFixed(2) : 0 }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? parseFloat(scope.row.c_report.direct_roi).toFixed(2) : 0 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="CIR (ACOS)" width="120px" prop="report.broad_cir"
                         v-if="m__is_show_index('broad_cir')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.broad_cir) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.broad_cir) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_cir')" width="120px" prop="report.direct_cir"
                         v-if="m__is_show_index('direct_cir')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.direct_cir) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.direct_cir) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.conversion_rate')" width="140px" prop="report.cr"
                         v-if="m__is_show_index('cr')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.cr) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.cr) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.direct_conversion_rate')" width="140px" prop="report.direct_cr"
                         v-if="m__is_show_index('direct_cr')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? (parseFloat(scope.row.report.direct_cr) * 100).toFixed(1) : 0 }} %

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? (parseFloat(scope.row.c_report.direct_cr) * 100).toFixed(1) : 0 }} %
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.cost_per_conversion')" width="150px" prop="report.cpc"
                         v-if="m__is_show_index('cpc')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cpc) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpc) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('metric.cost_per_direct_conversion')" width="140px" prop="report.cpdc"
                         v-if="m__is_show_index('cpdc')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cpdc) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpdc) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="AOV" width="120px" prop="report.aov"
                         v-if="m__is_show_atosa_index('aov')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.aov) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.aov) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="CPM" width="120px" prop="report.cpm"
                         v-if="m__is_show_atosa_index('cpm')" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.report ? m__calculate(scope.row.report.cpm) : 0 | currency }}

            <div v-if="is_compare_keyword" class="compare-keyword">
              {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpm) : 0 | currency }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-if="show_target_audience && is_full" style="margin-top: 40px">
      <strong style="font-size: 14px">{{ $t('base.audience') }}: {{ $t('base.manual_targeting') }}</strong>

      <div style="margin-top: 20px">
        <div v-if="target_audience_list.length">
          <el-table :data="target_audience_list" v-loading="loading.update_data || parent_campaign.loading">
            <el-table-column :label="$t('base.custom_audience')" width="330px">
              <template slot-scope="scope">
                <div style="padding-right: 10px; display: flex; flex-direction: column; gap: 5px">
                  <div>
                    <span style="font-size: 13px">{{ scope.row.group_name }}</span>
                  </div>
                  <div>
                    <span style="font-size: 12px">{{ $t('base.age') }}:</span>
                    <span style="font-size: 12px">
                      {{ m__map_audience_tag_name(scope.row, 'age') }}
                    </span>
                  </div>
                  <div>
                    <span style="font-size: 12px">{{ $t('base.gender') }}:</span>
                    <span style="font-size: 12px">
                      {{ m__map_audience_tag_name(scope.row, 'gender') }}
                    </span>
                  </div>
                  <div>
                    <span style="font-size: 12px">{{ $t('base.buyer_type') }}:</span>
                    <span style="font-size: 12px">
                      {{ m__map_audience_tag_name(scope.row, 'buyer') }}
                    </span>
                  </div>
                  <el-popover
                    placement="top"
                    width="300"
                    :ref="'popover-audience-' + scope.$index"
                    @click.native="target_audience_premium = scope.row.premium_rate / 1000">
                    <div>
                      <div>
                        <strong class="strong-label">{{ $t('base.premium_rate') }} (10% ~ 400%):</strong>
                        <el-input v-model="target_audience_premium" type="number" size="mini"
                                  placeholder="10% ~ 400%" :min="10" :max="400"></el-input>
                      </div>
                      <div style="margin-top: 20px" class="text-right">
                        <el-button type="primary" size="mini" icon="el-icon-check"
                                   @click="m__confirm_update_target_audience_premium(scope.row, scope.$index)">
                          {{ $t('base.confirm') }}
                        </el-button>
                      </div>
                    </div>
                    <div slot="reference" style="cursor: pointer">
                      <span style="font-size: 12px">Mức premium:</span>
                      <span style="font-size: 12px">
                        {{ (+scope.row.premium_rate / 1000).toFixed(1) }}
                        &nbsp;
                        <i class="el-icon-edit-outline"></i>
                      </span>
                    </div>
                  </el-popover>
                </div>

                <br>
                <span v-if="scope.row.auto_cir" style="position: relative" class="text-running"
                      @click="m__show_config_audience_auto_cir(scope.row)">
                  {{ $t('ads.optimize_based_on_cir') }}
                  <span
                    v-if="scope.row.auto_cir && scope.row.auto_cir.advancedDays && scope.row.auto_cir.advancedDays.length"
                    style="width: 5px; height: 5px; background-color: #ee4d2d; border-radius: 50px; position: absolute; z-index: 10"></span>
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.average_ranking')" width="120px" prop="report.average"
                             v-if="m__is_show_index('avg_rank')" sortable="custom">
              <template slot-scope="scope">
                <template v-if="scope.row.auto">-</template>
                <template v-else-if="scope.row.summary">-</template>
                <template v-else>
                  {{ scope.row.report ? scope.row.report.avg_rank : 0 | currency }}

                  <div v-if="is_compare_keyword" class="compare-keyword">
                    {{ scope.row.c_report ? scope.row.c_report.avg_rank : 0 | currency }}
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.impressions')" width="120px" prop="report.impression"
                             v-if="m__is_show_index('impression')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? scope.row.report.impression : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_report.impression : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.clicks')" width="120px" prop="report.click"
                             v-if="m__is_show_index('click')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? scope.row.report.click : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_report.click : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="CPC" width="120px" prop="report.atosa_cpc"
                             v-if="m__is_show_index('click')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? scope.row.report.atosa_cpc : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_report.atosa_cpc : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.ctr')" width="100px" prop="report.ctr"
                             v-if="m__is_show_index('ctr')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? (parseFloat(scope.row.report.ctr) * 100).toFixed(1) : '0.0' }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? (parseFloat(scope.row.c_report.ctr) * 100).toFixed(1) : '0.0' }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.conversions')" width="140px" prop="report.broad_order"
                             v-if="m__is_show_index('broad_order')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? scope.row.report.broad_order : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_report.broad_order : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_conversions')" width="115px" prop="report.direct_order"
                             v-if="m__is_show_index('direct_order')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? scope.row.report.direct_order : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_report.direct_order : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.items_sold')" width="150px" prop="report.broad_order_amount"
                             v-if="m__is_show_index('broad_order_amount')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? scope.row.report.broad_order_amount : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_report.broad_order_amount : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_items_sold')" width="125px" prop="report.direct_order_amount"
                             v-if="m__is_show_index('direct_order_amount')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? scope.row.report.direct_order_amount : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? scope.row.c_report.direct_order_amount : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="GMV" width="120px" prop="report.broad_gmv"
                             v-if="m__is_show_index('broad_gmv')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? m__calculate(scope.row.report.broad_gmv) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_report.broad_gmv) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_gmv')" width="130px" prop="report.direct_gmv"
                             v-if="m__is_show_index('direct_gmv')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? m__calculate(scope.row.report.direct_gmv) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_report.direct_gmv) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.expense')" width="100px" prop="report.cost"
                             v-if="m__is_show_index('cost')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? m__calculate(scope.row.report.cost) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_report.cost) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="ROI (ROAS)" width="120px" prop="report.broad_roi"
                             v-if="m__is_show_index('broad_roi')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? parseFloat(scope.row.report.broad_roi).toFixed(2) : 0 }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? parseFloat(scope.row.c_report.broad_roi).toFixed(2) : 0 }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_roi')" width="120px" prop="report.direct_roi"
                             v-if="m__is_show_index('direct_roi')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? parseFloat(scope.row.report.direct_roi).toFixed(2) : 0 }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? parseFloat(scope.row.c_report.direct_roi).toFixed(2) : 0 }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column label="CIR (ACOS)" width="120px" prop="report.broad_cir"
                             v-if="m__is_show_index('broad_cir')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? (parseFloat(scope.row.report.broad_cir) * 100).toFixed(1) : 0 }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? (parseFloat(scope.row.c_report.broad_cir) * 100).toFixed(1) : 0 }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_cir')" width="120px" prop="report.direct_cir"
                             v-if="m__is_show_index('direct_cir')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? (parseFloat(scope.row.report.direct_cir) * 100).toFixed(1) : 0 }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? (parseFloat(scope.row.c_report.direct_cir) * 100).toFixed(1) : 0 }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.conversion_rate')" width="140px" prop="report.cr"
                             v-if="m__is_show_index('cr')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? (parseFloat(scope.row.report.cr) * 100).toFixed(1) : 0 }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? (parseFloat(scope.row.c_report.cr) * 100).toFixed(1) : 0 }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.direct_conversion_rate')" width="140px" prop="report.direct_cr"
                             v-if="m__is_show_index('direct_cr')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? (parseFloat(scope.row.report.direct_cr) * 100).toFixed(1) : 0 }} %

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? (parseFloat(scope.row.c_report.direct_cr) * 100).toFixed(1) : 0 }} %
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.cost_per_conversion')" width="150px" prop="report.cpc"
                             v-if="m__is_show_index('cpc')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? m__calculate(scope.row.report.cpc) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpc) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('metric.cost_per_direct_conversion')" width="140px" prop="report.cpdc"
                             v-if="m__is_show_index('cpdc')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? m__calculate(scope.row.report.cpdc) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpdc) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="AOV" width="120px" prop="report.aov"
                             v-if="m__is_show_atosa_index('aov')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? m__calculate(scope.row.report.aov) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_report.aov) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="CPM" width="120px" prop="report.cpm"
                             v-if="m__is_show_atosa_index('cpm')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.report ? m__calculate(scope.row.report.cpm) : 0 | currency }}

                <div v-if="is_compare_keyword" class="compare-keyword">
                  {{ scope.row.c_report ? m__calculate(scope.row.c_report.cpm) : 0 | currency }}
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="m__check_marketing_package('auto_campaign')" :label="$t('base.action')" width="130px"
                             fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" :disabled="scope.row.status === 'disabled'"
                           @click="m__show_update_target_audience_dialog(scope.row)">
                  <strong class="text-primary">{{ $t('base.edit') }}</strong>
                </el-button>
                <br>
                <el-button v-if="scope.row.status === 'enabled'" type="text" size="mini"
                           @click="m__confirm_update_target_audience_status(scope.row, 'disable')">
                  <strong class="text-primary"> {{ $t('ads.pause') }}</strong>
                </el-button>
                <el-button v-else type="text" size="mini"
                           @click="m__confirm_update_target_audience_status(scope.row, 'enable')">
                  <strong class="text-primary">{{ $t('base.active') }}</strong>
                </el-button>
                <br>
                <el-button type="text" size="mini"
                           @click="m__show_config_audience_auto_cir">
                  <strong class="text-primary"> {{ $t('ads.automatic_configuration') }} </strong>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-button type="primary" size="small" icon="el-icon-plus"
                     @click="m__show_update_target_audience_dialog(null)">
            {{ $t('ads.new_custom_audience') }}
          </el-button>
          <br>
          <br>
          <span>
            {{ $t('ads.audience_note') }}
          </span>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="show_dialog.update_keyword_price" :close-on-click-modal="false"
               width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit_bid_price') }}</strong>

        <p class="text-title" style="">{{ $t('base.bid_price') }}</p>
        <el-input type="number" size="mini" v-model="base_price"></el-input>

        <div class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" style="margin-top: 10px"
                     @click="m__update_ads_price" :loading="loading.update_keyword_price">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.config_auto_campaign" :close-on-click-modal="false"
               width="1250px">
      <div slot="title" style="padding:10px">
        <el-row style="background-color: #F1F1F1">
          <el-col :sm="5" style="padding-top: 10px;">
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 2 ? 'config-tab-active': ''" @click="config_tab = 2">
              <span style="font-size: 13px; font-weight: 700;">
                {{ $t('ads.auto_position_configuration') }}
              </span>
              <div v-if="selected_ads && selected_ads.auto_position"
                   style="margin-left: 10px; width:8px; display: inline-block; height:8px; background-color: #11ce65; border-radius:50vh;">
              </div>
            </div>
            <div style="padding: 0 30px; width: 100%; margin-top: 10px; margin-bottom: 10px">
              <div style="height: 0; width: 100%; border-top: 1px solid #cecece"></div>
            </div>
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 3 ? 'config-tab-active': ''" @click="config_tab = 3">
              <span style="font-size: 13px;  font-weight: 700">{{ $t('base.configuration_setup_guide') }}</span>
            </div>
          </el-col>

          <el-col :sm="19" style="background-color: #FFF;">
            <template v-if="config_tab === 2">
              <el-row style="padding: 0 10px; margin-top: 10px">
                <el-col :sm="13" style="padding-right: 30px">
                  <el-radio v-model="form_config_auto_position.type" :label="1">{{ $t('ads.auto_position') }}</el-radio>
                  <el-row style="padding-left: 15px">
                    <el-col :sm="12" style="padding-right: 10px">
                      <p class="text-title">{{ $t('ads.auto_position_label.from_position') }}:</p>
                      <el-input v-model="form_config_auto_position.fromValue" size="mini" type="number"
                                :placeholder="$t('ads.auto_position_label.input_from')"></el-input>
                    </el-col>
                    <el-col :sm="12" style="padding-right: 10px">
                      <p class="text-title">{{ $t('ads.auto_position_label.to_position') }}:</p>
                      <el-input v-model="form_config_auto_position.toValue" size="mini" type="number"
                                :placeholder="$t('ads.auto_position_label.input_to')"></el-input>
                    </el-col>
                  </el-row>

                  <br><br>

                  <el-radio v-model="form_config_auto_position.type" :label="2">
                    {{ $t('ads.auto_position_label.always_above') }}
                  </el-radio>
                  <el-row style="padding-left: 15px">
                    <el-col :sm="12" style="padding-right: 10px">
                      <el-input v-model="form_config_auto_position.upValue" size="mini" type="number"
                                :placeholder="$t('ads.auto_position_label.input_position')"></el-input>
                    </el-col>
                  </el-row>

                  <br><br>

                  <el-radio v-model="form_config_auto_position.type" :label="3">
                    {{ $t('ads.auto_position_label.always_below') }}
                  </el-radio>
                  <el-row style="padding-left: 15px">
                    <el-col :sm="12" style="padding-right: 10px">
                      <el-input v-model="form_config_auto_position.downValue" size="mini" type="number"
                                :placeholder="$t('ads.auto_position_label.input_position')"></el-input>
                    </el-col>
                  </el-row>

                  <br>

                  <div style="padding-left: 5px">
                    <p class="text-title">{{ $t('ads.other_setups') }}({{ $t('base.optional') }}):</p>
                    <el-row style="padding-left: 15px">
                      <el-col :sm="12" style="padding-right: 10px">
                        <p class="text-title">{{ $t('ads.check_position_on') }}</p>
                        <el-select size="mini" class="full-w" value="avg_rank"
                                   :placeholder="$t('base.select')">
                          <el-option value="avg_rank" :label="$t('ads.average_ranking')"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :sm="12" style="padding-right: 10px">
                      </el-col>
                    </el-row>
                    <el-row style="padding-left: 15px">
                      <el-col :sm="12" style="padding-right: 10px">
                        <p class="text-title">{{ $t('ads.auto_position_label.bid_price_to_increase') }}:</p>
                        <el-input v-model="form_config_auto_position.maxValue" size="mini" type="number"></el-input>
                      </el-col>
                      <el-col :sm="12" style="padding-right: 10px">
                        <p class="text-title"> {{ $t('base.max_bid_price') }}:</p>
                        <el-input v-model="form_config_auto_position.maxPrice" size="mini" type="number"></el-input>
                      </el-col>
                    </el-row>
                    <el-row style="padding-left: 15px">
                      <el-col :sm="12" style="padding-right: 10px">
                        <p class="text-title">{{ $t('ads.auto_position_label.bid_price_to_decrease') }}:</p>
                        <el-input v-model="form_config_auto_position.minValue" size="mini" type="number"></el-input>
                      </el-col>
                      <el-col :sm="12" style="padding-right: 10px">
                        <p class="text-title">
                          {{ $t('base.min_bid_price') }} ({{ $t('base.min') }} {{ TARGETING_MIN }}):
                        </p>
                        <el-input v-model="form_config_auto_position.minPrice" size="mini" type="number"></el-input>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :sm="11" style="padding: 0 15px">
                  <div style="height: 24px"></div>
                  <p class="text-title" style=""> {{ $t('base.configuration_runtime_list') }} </p>

                  <ComponentCustomTimePicker style="margin-top: 30px"
                                             :value.sync="form_config_auto_position.times"></ComponentCustomTimePicker>

                  <br>
                  <p class="text-title" style=""> {{ $t('base.set_when_outside_runtime') }} </p>
                  <el-select size="mini" value="" class="full-w" v-model="form_config_auto_position.stop_action">
                    <el-option :value="0" :label="$t('base.keep_bid_price')"></el-option>
                    <el-option :value="1" :label="$t('base.pause_ad')"></el-option>
                    <el-option :value="3" :label="$t('ads.general_label.edit_amount')"></el-option>
                    <el-option
                      v-if="[].some(i => $store.state.userInfo.username.includes(i))"
                      :value="4" :label="$t('ads.general_label.edit_by_realtime_cpc')"></el-option>
                  </el-select>

                  <template v-if="form_config_auto_position.stop_action === 3">
                    <p class="text-title" style="">{{ $t('base.bid_price') }}</p>
                    <el-input type="number" size="mini" v-model="form_config_auto_position.stop_action_3"
                              :placeholder="$t('input.bid_price')"></el-input>
                  </template>
                </el-col>
              </el-row>
              <br>
              <div style="margin-top: 10px" class="text-right">
                <el-button size="mini" type="danger"
                           v-if="selected_ads && selected_ads.auto_position && !select_multiple"
                           @click="m__delete_config_auto_position" icon="el-icon-delete">
                  {{ $t('base.delete_config') }}
                </el-button>
                <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.auto_position"
                           @click="m__save_config_auto_position">
                  {{ $t('base.save_config') }}
                </el-button>
              </div>
            </template>

            <template v-if="config_tab === 3">
              <ComponentTargetingAutoPositionGuide></ComponentTargetingAutoPositionGuide>
            </template>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_campaign_quota" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit') }} {{ $t('base.budget') }}</strong>

        <div>
          <el-radio v-model="selected_quota_type" label="1">{{ $t('base.unlimited') }}</el-radio>
          <br>
          <el-radio v-model="selected_quota_type" label="2">{{ $t('base.set_budget') }}</el-radio>
          <el-row v-if="selected_quota_type === '2'">
            <el-col :sm="12" style="padding-right: 10px">
              <el-input size="mini" type="number" :min="DAILY_BUDGET_MIN" v-model="campaign_quota.quota"></el-input>
            </el-col>
            <el-col :sm="12" style="padding-right: 10px">
              <el-select size="mini" class="full-w" value="" v-model="campaign_quota.type">
                <el-option value="daily" :label="$t('base.daily_budget')"></el-option>
              </el-select>
            </el-col>
          </el-row>

          <el-row class="text-right" style="margin-top: 10px">
            <el-button size="mini" type="primary" :loading="loading.update_campaign_quota"
                       @click="m__update_campaign_quota">{{ $t('base.confirm') }}
            </el-button>
          </el-row>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_campaign_date" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit') }} {{ $t('ads.duration') }}</strong>

        <el-radio v-model="selected_time_type" label="unlimited">{{ $t('base.no_end_date') }}</el-radio>
        <br>
        <el-radio v-model="selected_time_type" label="from_to">{{ $t('ads.select_duration') }}</el-radio>
        <el-row v-if="selected_time_type === 'from_to'">
          <el-col :sm="12">
            <el-date-picker v-model="campaign_time.start_time" format="dd-MM-yyyy" size="mini"></el-date-picker>
          </el-col>
          <el-col :sm="12">
            <el-date-picker :placeholder="$t('base.select_end_time')" v-model="campaign_time.end_time"
                            format="dd-MM-yyyy"
                            size="mini"></el-date-picker>
          </el-col>
        </el-row>

        <el-row class="text-right" style="margin-top: 10px">
          <el-button size="mini" type="primary" @click="m__update_campaign_date"
                     :loading="loading.update_campaign_date">{{ $t('base.confirm') }}
          </el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.compare_keyword" :close-on-click-modal="false" width="450px">
      <div slot="title" style="padding:10px">
        <strong style="font-size:14px">{{ $t('base.compare_data') }}</strong>

        <br>
        <br>
        <div style="line-height: 20px">
          <strong style="font-size:13px"> {{ $t('base.current_duration') }}:</strong>
          <br>
          <strong style="font-size: 13px" class="text-danger"> {{ $t('base.from_date') }}:
            {{ start_date | moment('DD-MM-YYYY') }} - {{ $t('base.to_date') }}: {{
              end_date | moment('DD-MM-YYYY')
            }}</strong>

          <br>
          <br>

          <strong style="font-size:13px"> {{ $t('select.compare_duration') }}:</strong>
          <br>
          <el-date-picker v-model="compare_date_range" type="daterange" range-separator="-"
                          :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
                          format="dd-MM-yyyy"
                          :clearable="false" :picker-options="picker_options">
          </el-date-picker>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button size="mini" type="danger" @click="is_compare_keyword = false; show_dialog.compare_keyword = false">
            {{ $t('base.disable_compare_data') }}
          </el-button>
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_compare_keyword"
                     :loading="loading.compare_keyword">{{ $t('base.execute') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.config_anti_click" :close-on-click-modal="false" width="1000px">
      <div slot="title" style="padding:10px">
        <el-row style="background-color: #F1F1F1">
          <el-col :sm="6" style="padding-top: 10px;">
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 4 ? 'config-tab-active': ''" @click="config_tab = 4">
              <span style="font-size: 13px; font-weight: 700;">
                {{ $t('ads.anti_click_configuration') }}
              </span>
              <div v-if="selected_ads && selected_ads.anti_click"
                   style="margin-left: 10px; width:8px; display: inline-block; height:8px; background-color: #11ce65; border-radius:50vh;">
              </div>
            </div>
            <div style="padding: 0 30px; width: 100%; margin-top: 10px; margin-bottom: 10px">
              <div style="height: 0; width: 100%; border-top: 1px solid #cecece"></div>
            </div>
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 5 ? 'config-tab-active': ''" @click="config_tab = 5">
              <span style="font-size: 13px;  font-weight: 700">
                {{ $t('base.configuration_setup_guide') }}
              </span>
            </div>
          </el-col>
          <el-col :sm="18" style="background-color: #FFF;">
            <template v-if="config_tab === 4">
              <div style="padding: 20px 0 20px 30px">
                <el-row>
                  <el-col :sm="12" style="padding-right: 60px">
                    <div>
                      <p class="text-title" style="">
                        <el-radio v-model="form_anti_click.type" label="1">
                          <strong>{{ $t('ads.anti_click_label.type1') }}</strong>
                        </el-radio>
                      </p>
                      <el-input size="mini" type="number" v-model="form_anti_click.ratio"></el-input>

                      <p class="text-title" style=""> {{ $t('ads.anti_click_label.minimum_clicks') }} </p>
                      <el-input size="mini" type="number" v-model="form_anti_click.click_minimum_number"></el-input>

                      <p class="text-title" style=""> {{ $t('ads.anti_click_label.maximum_clicks') }} </p>
                      <el-input size="mini" type="number" v-model="form_anti_click.click_maximum_number"></el-input>
                    </div>
                  </el-col>
                  <el-col :sm="12" style="padding-right: 30px">
                    <p class="text-title" style="">
                      <el-radio v-model="form_anti_click.type" label="2"><strong>2. {{
                          $t('ads.anti_click_label.type2')
                        }}</strong>
                      </el-radio>
                    </p>
                    <el-row>
                      <el-col :sm="15" style="padding-right: 10px">
                        <el-input :disabled="form_anti_click.type === '1'" size="mini" type="number"
                                  v-model="form_anti_click.cir"></el-input>
                      </el-col>
                      <el-col :sm="9">
                        <el-select size="mini" class="full-w" value="" v-model="form_anti_click.is_direct_cir"
                                   :disabled="form_anti_click.type === '1'">
                          <el-option :value="0" :label="$t('ads.anti_click_label.broad_cir')"></el-option>
                          <el-option :value="1" :label="$t('ads.anti_click_label.direct_cir')"></el-option>
                        </el-select>
                      </el-col>
                    </el-row>

                    <el-row>
                      <el-col :sm="24">
                        <p class="text-title" style="">{{ $t('ads.anti_click_label.maximum_cost') }}
                          ({{ $t('base.not_required') }})</p>
                        <el-input v-model="form_anti_click.max_cost" size="mini" :placeholder="$t('input.max_cost')"
                                  type="number" :disabled="form_anti_click.type === '1'"></el-input>
                      </el-col>
                    </el-row>

                    <p class="text-title" style="">{{ $t('ads.get_cir_by') }}</p>
                    <el-select v-model="form_anti_click.time_type" size="mini" value="" class="full-w"
                               :disabled="form_anti_click.type === '1'">
                      <el-option value="today" :label="$t('base.today')"></el-option>
                      <el-option value="yesterday" :label="$t('base.yesterday')"></el-option>
                      <el-option value="week" :label="$t('base.last_week')"></el-option>
                      <el-option value="month" :label="$t('base.last_month')"></el-option>
                    </el-select>

                    <br>
                    <br>
                    <span style="padding-left: 1px">
                      <el-checkbox v-model="form_anti_click.not_order" :disabled="form_anti_click.type === '1'"
                                   size="small">
                        {{ $t('ads.anti_click_label.check_if_gmv_by_0') }}
                      </el-checkbox>
                    </span>
                    <p class="text-title" style="margin-top: 1px !important;">
                      {{ $t('ads.auto_cir_label.max_cost_if_gmv_by_0') }}
                    </p>
                    <el-input v-model="form_anti_click.min_cost" size="mini" :placeholder="$t('input.max_cost')"
                              type="number"
                              :disabled="form_anti_click.type === '1' || !form_anti_click.not_order"></el-input>
                  </el-col>
                </el-row>

                <div style="padding-right: 30px">
                  <p class="text-title" style="">{{ $t('ads.anti_click_label.action_when_detect') }}</p>
                  <el-select value="" v-model="form_anti_click.detect_type" size="mini" class="full-w">
                    <el-option :value="1" :label="$t('base.pause_ad')"></el-option>
                    <el-option :value="3" :label="$t('ads.edit_by_bid_price')"></el-option>
                  </el-select>

                  <template v-if="form_anti_click.detect_type === 3">
                    <p class="text-title" style="">{{ $t('base.bid_price') }}:</p>
                    <el-input size="mini" type="number" v-model="form_anti_click.detect_value_3"></el-input>
                  </template>
                </div>

                <div class="text-right" style="padding-right: 30px; margin-top: 30px;">
                  <el-button v-if="selected_ads && selected_ads.anti_click" size="small" type="danger"
                             icon="el-icon-delete" @click="m__delete_anti_click_single">{{ $t('base.delete_config') }}
                  </el-button>
                  <el-button size="small" type="primary" icon="el-icon-check" @click="m__confirm_anti_click_single"
                             :loading="loading.config_anti_click">
                    {{ $t('base.save_config') }}
                  </el-button>
                </div>
              </div>
            </template>

            <template v-if="config_tab === 5">
              <ComponentAntiClickGuide></ComponentAntiClickGuide>
            </template>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_target_broad_roi" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit_target_roas') }}</strong>

        <div>
          <div>
            <el-radio v-model="form_update_target_broad_roi.type" :label="'auto'">
              {{ $t('ads.gmv_max_auto_title') }}
            </el-radio>
            <div>
              {{ $t('ads.gmv_max_auto_description') }}
            </div>
          </div>

          <div style="margin-top: 30px">
            <el-radio v-model="form_update_target_broad_roi.type" :label="'custom'">
              {{ $t('ads.gmv_max_custom_title') }}
            </el-radio>
            <div>
              {{ $t('ads.gmv_max_custom_description') }}
            </div>
          </div>
          <div v-if="form_update_target_broad_roi.type === 'custom'"
               style="margin-top: 20px; padding-left: 10px; display: flex; flex-direction: column; gap: 10px">
            <div v-for="item in form_update_target_broad_roi.custom_type_list" :key="item" style="display: flex">
              <div style="width: 150px">
                <el-radio v-model="form_update_target_broad_roi.custom_type" :label="item">
                  ROAS = {{ item / 100000 }}
                </el-radio>
              </div>
              <div>

              </div>
            </div>
            <div style="display: flex">
              <div style="width: 150px; padding-top: 6px">
                <el-radio v-model="form_update_target_broad_roi.custom_type" :label="'custom'">
                  {{ $t('create_ads.custom') }}
                </el-radio>
              </div>
              <div style="flex: 1; padding-right: 12px">
                <el-input type="number" v-model="form_update_target_broad_roi.custom_value" :min="1" :max="50"
                          size="mini" placeholder="1.0 ~ 50.0">
                </el-input>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.update_target_broad_roi"
                     @click="m__confirm_update_target_broad_roi">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_target_audience" :close-on-click-modal="false"
               width="600px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.edit_audience') }}</strong>

        <div style="display: flex; flex-direction: column; gap: 20px">
          <div style="display: flex">
            <div style="width: 140px">{{ $t('base.audience_name') }}</div>
            <div style="flex: 1">
              <el-input size="mini" v-model="target_audience_form.group_name"></el-input>
            </div>
          </div>
          <div style="display: flex">
            <div style="width: 140px">{{ $t('base.age') }}</div>
            <div style="flex: 1; display: flex; gap: 5px">
              <el-checkbox-group v-model="target_audience_form.age">
                <el-checkbox label="all"
                             @click.native="target_audience_form.age = target_audience_form.age.filter(i => i === 'all')">
                  {{ $t('base.all') }}
                </el-checkbox>
                <el-checkbox label="age__18_24"
                             @click.native="target_audience_form.age = target_audience_form.age.filter(i => i !== 'all')">
                  18-24
                </el-checkbox>
                <el-checkbox label="age__25_34"
                             @click.native="target_audience_form.age = target_audience_form.age.filter(i => i !== 'all')">
                  25-34
                </el-checkbox>
                <el-checkbox label="age__35_plus"
                             @click.native="target_audience_form.age = target_audience_form.age.filter(i => i !== 'all')">
                  35+
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div style="display: flex">
            <div style="width: 140px">{{ $t('base.gender') }}</div>
            <div style="flex: 1; display: flex; gap: 5px">
              <el-radio v-model="target_audience_form.gender" label="all">{{ $t('base.all') }}</el-radio>
              <el-radio v-model="target_audience_form.gender" label="gender__men">{{ $t('base.men') }}</el-radio>
              <el-radio v-model="target_audience_form.gender" label="gender__women">{{ $t('base.women') }}</el-radio>
            </div>
          </div>
          <div style="display: flex">
            <div style="width: 140px">{{ $t('base.buyer_type') }}</div>
            <div style="flex: 1; display: flex; gap: 5px">
              <el-radio v-model="target_audience_form.buyer " label="all">{{ $t('base.all') }}</el-radio>
              <el-radio v-model="target_audience_form.buyer" label="buyer__new">{{
                  $t('base.potential_new_buyers')
                }}
              </el-radio>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.update_target_audience"
                     @click="m__confirm_update_target_audience">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.update_pricing_type" :close-on-click-modal="false"
               width="500px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.shopee_advanced_settings') }}</strong>

        <div style="display: flex; align-items: center; gap: 10px">
          <el-switch v-model="pricing_type" :active-value="2" :inactive-value="1"></el-switch>
          <span>{{ $t('base.enhanced_bid_price') }}</span>
        </div>

        <div style="margin-top: 20px">
          {{ $t('base.shopee_advanced_settings_note') }}
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.update_pricing_type"
                     @click="m__confirm_update_pricing_type">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.config_audience_auto_cir" :close-on-click-modal="false" width="800px">
      <div slot="title" style="padding:10px">
        <el-row style="background-color: #F1F1F1">
          <el-col :sm="7" style="padding-top: 10px;">
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 6 ? 'config-tab-active': ''" @click="config_tab = 6">
              <span style="font-size: 13px; font-weight: 700">{{ $t('ads.optimize_audience_based_on_cir') }}</span>
            </div>
            <div style="padding: 0 30px; width: 100%; margin-top: 10px; margin-bottom: 10px">
              <div style="height: 0; width: 100%; border-top: 1px solid #cecece"></div>
            </div>
            <div style="padding: 15px 15px; width: 100%; cursor: pointer; margin-bottom: 5px"
                 :class="config_tab === 7 ? 'config-tab-active': ''" @click="config_tab = 7">
              <span style="font-size: 13px;  font-weight: 700">{{ $t('base.configuration_setup_guide') }}</span>
            </div>
          </el-col>
          <el-col :sm="17" style="background-color: #FFF;">
            <template v-if="config_tab === 6">
              <div style="padding: 10px 10px 10px 30px">
                <el-row>
                  <el-col :sm="16" style="padding-right: 10px">
                    <p class="text-title"> {{ $t('base.expected_cir') }}(%):</p>
                    <el-input v-model="form_config_audience_auto_cir.fromCir" size="mini" type="number"
                              :placeholder="$t('input.expected_cir')"></el-input>
                  </el-col>
                  <el-col :sm="8">
                    <p class="text-title">&nbsp</p>
                    <el-select v-model="form_config_audience_auto_cir.cirType" size="mini" value="" class="full-w">
                      <el-option value="broad" :label="$t('ads.anti_click_label.broad_cir')"></el-option>
                      <el-option value="direct" :label="$t('ads.anti_click_label.direct_cir')"></el-option>
                    </el-select>
                  </el-col>
                </el-row>

                <el-row style="margin-top: 15px">
                  <strong class="strong-label">{{ $t('ads.get_cir_by') }}</strong>
                  <el-select v-model="form_config_audience_auto_cir.timeType" size="mini" value="" class="full-w">
                    <el-option value="today" :label="$t('base.today')"></el-option>
                    <el-option value="yesterday" :label="$t('base.yesterday')"></el-option>
                    <el-option value="week" :label="$t('base.last_week')"></el-option>
                    <el-option value="month" :label="$t('base.last_month')"></el-option>
                  </el-select>
                </el-row>

                <hr>
                <div style="margin-top: 15px"></div>
                <strong>{{ $t('base.edit') }} {{ $t('base.premium_rate') }} {{
                    $t('ads.auto_cir_label.to_reach_target')
                  }}</strong>
                <el-row>
                  <el-col :sm="14" style="padding-right: 10px">
                    <p class="text-title">{{ $t('base.bonus_premium_rate') }}:</p>
                    <el-input v-model="form_config_audience_auto_cir.price" size="mini" type="number"
                              :placeholder="$t('input.bonus_premium_rate')"
                              :disabled="!form_config_audience_auto_cir.allowBidPrice"></el-input>
                  </el-col>
                  <el-col :sm="10">
                    <p class="text-title">{{ $t('base.max_premium_rate') }}:</p>
                    <el-input v-model="form_config_audience_auto_cir.maxPrice" size="mini" type="number"
                              :placeholder="$t('input.max_premium_rate')"
                              :disabled="!form_config_audience_auto_cir.allowBidPrice"></el-input>
                  </el-col>
                </el-row>

                <div style="margin-top: 15px"></div>
                <hr>
                <el-checkbox v-model="form_config_audience_auto_cir.allowAtCase1" size="small">
                  {{ $t('ads.auto_cir_label.audience_allow_case_1') }}
                </el-checkbox>
                <p class="text-title">{{ $t('base.action_plan') }}</p>
                <div>
                  <el-select v-model="form_config_audience_auto_cir.case1Type" value="" size="mini" class="full-w"
                             :disabled="!form_config_audience_auto_cir.allowAtCase1">
                    <el-option value="stop" :label="$t('ads.auto_cir_label.audience_pause')"></el-option>
                    <el-option value="value" :label="$t('ads.auto_cir_label.audience_value')"></el-option>
                    <el-option value="reduce" :label="$t('ads.auto_cir_label.audience_reduce')"></el-option>
                  </el-select>
                </div>
                <div v-if="form_config_audience_auto_cir.case1Type === 'value'" style="margin-top: 10px">
                  <el-input v-model="form_config_audience_auto_cir.case1Value"
                            size="mini" type="number" :placeholder="$t('input.premium_rate')"
                            :disabled="!form_config_audience_auto_cir.allowAtCase1"></el-input>
                </div>
                <div v-if="form_config_audience_auto_cir.case1Type === 'reduce'" style="margin-top: 10px">
                  <el-row>
                    <el-col :sm="12" style="padding-right: 5px">
                      <el-input v-model="form_config_audience_auto_cir.case1Reduce"
                                size="mini" type="number" :placeholder="$t('input.reduction_premium_rate')"
                                :disabled="!form_config_audience_auto_cir.allowAtCase1"></el-input>
                    </el-col>
                    <el-col :sm="12" style="padding-left: 5px">
                      <el-input v-model="form_config_audience_auto_cir.case1ReduceMin"
                                size="mini" type="number" :placeholder="$t('input.min_premium_rate')"
                                :disabled="!form_config_audience_auto_cir.allowAtCase1"></el-input>
                    </el-col>
                  </el-row>
                </div>

                <hr>
                <el-row style="margin-top: 15px">
                  <el-checkbox v-model="form_config_audience_auto_cir.allowAtCase2" size="small">
                    {{ $t('ads.anti_click_label.check_if_gmv_by_0') }}
                  </el-checkbox>
                  <p class="text-title">{{ $t('ads.auto_cir_label.audience_max_cost_if_gmv_by_0') }}</p>
                  <el-input v-model="form_config_audience_auto_cir.case2Min" size="mini"
                            :placeholder="$t('input.max_cost')"
                            type="number"
                            :disabled="!form_config_audience_auto_cir.allowAtCase2"></el-input>

                  <br>
                  <p class="text-title" style="margin-top: 10px !important;">{{ $t('base.action_plan') }}</p>
                  <div>
                    <el-select v-model="form_config_audience_auto_cir.case2Type" value="" size="mini" class="full-w"
                               :disabled="!form_config_audience_auto_cir.allowAtCase2">
                      <el-option value="stop" :label="$t('ads.auto_cir_label.audience_pause')"></el-option>
                      <el-option value="value" :label="$t('ads.auto_cir_label.audience_value')"></el-option>
                      <el-option value="reduce" :label="$t('ads.auto_cir_label.audience_reduce')"></el-option>
                    </el-select>
                  </div>
                  <div v-if="form_config_audience_auto_cir.case2Type === 'value'" style="margin-top: 10px">
                    <el-input v-model="form_config_audience_auto_cir.case2Value"
                              size="mini" type="number" :placeholder="$t('input.premium_rate')"
                              :disabled="!form_config_audience_auto_cir.allowAtCase2"></el-input>
                  </div>
                  <div v-if="form_config_audience_auto_cir.case2Type === 'reduce'" style="margin-top: 10px">
                    <el-row>
                      <el-col :sm="12" style="padding-right: 5px">
                        <el-input v-model="form_config_audience_auto_cir.case2Reduce"
                                  size="mini" type="number" :placeholder="$t('input.reduction_premium_rate')"
                                  :disabled="!form_config_audience_auto_cir.allowAtCase2"></el-input>
                      </el-col>
                      <el-col :sm="12" style="padding-left: 5px">
                        <el-input v-model="form_config_audience_auto_cir.case2ReduceMin"
                                  size="mini" type="number" :placeholder="$t('input.min_premium_rate')"
                                  :disabled="!form_config_audience_auto_cir.allowAtCase2"></el-input>
                      </el-col>
                    </el-row>
                  </div>
                </el-row>

                <el-row style="margin-top: 30px">
                  <el-col :sm="24" class="text-right">
                    <el-button size="mini" type="danger" icon="el-icon-delete"
                               @click="m__delete_audience_auto_cir">
                      {{ $t('base.delete_config') }}
                    </el-button>
                    <el-button size="mini" type="primary" icon="el-icon-check"
                               @click="m__confirm_save_audience_auto_cir"
                               :loading="loading.config_audience_auto_cir">
                      {{ $t('base.save_config') }}
                    </el-button>
                  </el-col>
                </el-row>
              </div>
            </template>

            <template v-if="config_tab === 7">
              <div style="padding: 20px">
                <p style="font-size: 14px">- {{ $t('ads.auto_cir_label.audience_user_guide') }}</p>
              </div>
            </template>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.operation_history" :close-on-click-modal="false" width="1200px">
      <div slot="title" style="padding:10px">
        <div slot="title" style="padding:10px">
          <strong class="strong-title">{{ $t('ads.operation_history') }}</strong>

          <div style="margin-top: 30px">
            <ComponentShopeeOperationHistory :campaign_id="c__campaign_id" :shop="shop" :sp_user="sp_user"
                                             :show_dialog="show_dialog.operation_history"></ComponentShopeeOperationHistory>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.create_tag" :close-on-click-modal="false" width="400px">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('base.manage_tags') }}</strong>

        <div style="margin-top: 30px">
          <div v-for="tag in keyword_tag_list" :key="tag.name"
               style="background-color: #eef0f1; padding: 10px; margin-bottom: 10px; border-radius: 4px; display: flex; align-items: center">
            <div style="flex: auto; font-size: 14px; padding-right: 10px">
              <template v-if="tag.editable">
                <el-input size="mini" v-model="tag.temp_name"></el-input>
              </template>
              <template v-else>
                {{ tag.name }}
              </template>
            </div>
            <div style="width: 60px">
              <template v-if="tag.editable">
                <a href="javascript:void(0)" @click="m__update_keyword_tag(tag)">
                  <i class="el-icon-check" style="font-size: 14px; color: #000"></i>
                </a>
                &nbsp;&nbsp;
                <a href="javascript:void(0)" @click="m__toggle_update_keyword_tag(tag, false)">
                  <i class="el-icon-close" style="font-size: 14px; color: #000"></i>
                </a>
              </template>
              <template v-else>
                <a href="javascript:void(0)" @click="m__toggle_update_keyword_tag(tag, true)">
                  <i class="el-icon-edit" style="font-size: 14px; color: #000"></i>
                </a>
                &nbsp;&nbsp;
                <a href="javascript:void(0)">
                  <i class="el-icon-delete" style="font-size: 14px; color: #000"
                     @click="m__delete_keyword_tag(tag)"></i>
                </a>
              </template>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px; display: flex; gap: 10px">
          <div style="flex: auto">
            <el-input size="mini" :placeholder="$t('input.tag_name')" v-model="keyword_tag_name"></el-input>
          </div>
          <div style="flex: 1">
            <el-button type="primary" size="mini" icon="el-icon-plus" :loading="loading.create_tag"
                       @click="m__create_keyword_tag"> {{ $t('base.create_tags') }}
            </el-button>
          </div>
        </div>

        <div style="margin-top: 10px"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {maxBy as _maxBy, minBy as _minBy, orderBy as _orderBy} from 'lodash'
import ComponentMetric from '../component/component_metric.vue'
import {atosa_flag, base_flag, default_report, picker_options} from '../../../addon/options'
import {auto_optimize_fixed_list} from '../../../addon/fixed_list'
import {make_uuid} from '../../../addon/ads_function'
import ComponentTargetingAutoPositionGuide from '../component/component_targeting_auto_position_guide.vue'
import ComponentAntiClickGuide from "../component/component_anti_click_guide.vue";
import {fix_ads_mixins} from "../../../mixins/fix_ads";
import ComponentShopeeOperationHistory from "../component/component_shopee_operation_history.vue";
import {package_mixins} from "../../../mixins/package";
import ComponentCustomTimePicker from "../component/component_custom_time_picker.vue";
import {validate_mixins} from "../../../mixins/validate";

export default {
  name: 'page__targeting_marketing_detail',

  mixins: [fix_ads_mixins, package_mixins, validate_mixins],

  components: {
    ComponentShopeeOperationHistory,
    ComponentMetric,
    ComponentTargetingAutoPositionGuide,
    ComponentAntiClickGuide,
    ComponentCustomTimePicker
  },

  props: {
    shop: {},
    parent_campaign: {},
    sp_user: {},
    start_date: null,
    end_date: null,
    parent_is_compare_campaign: false,
    parent_compare_date_range: null,
    expected_cir: null,
    is_full: {
      type: Boolean,
      default: true
    },
    parent_flag: null,
    ads_config: {},
    non_ads_data: {},
    show_tags: false
  },

  data() {
    return {
      campaign: {
        advertisements: [],
        campaign: {},
        product: {}
      },
      advertisement_list: [],
      selected_ads: {
        extinfo: {target: {price: null}}
      },
      search_keywords: '',
      base_price: null,
      premium_rate: null,
      show_dialog: {
        update_keyword_price: false,
        add_keywords: false,
        update_multiple_keyword_price: false,
        update_multiple_keyword_match_type: false,
        remove_multiple_keyword: false,
        config_auto_campaign: false,
        update_campaign_quota: false,
        update_campaign_date: false,
        update_premium_rate: false,
        select_index: false,
        compare_keyword: false,
        config_anti_click: false,
        buyer_segment: false,
        config_auto_optimize: false,
        openai: false,
        update_target_broad_roi: false,
        update_target_audience: false,
        update_price1: false,
        update_price2: false,
        update_pricing_type: false,
        config_audience_auto_cir: false,
        operation_history: false,
        create_tag: false
      },
      loading: {
        update_keyword_price: false,
        add_keywords: false,
        confirm_add_keywords: false,
        update_multiple_keyword_price: false,
        update_multiple_keyword_match_type: false,
        remove_multiple_keyword: false,
        config_auto_campaign: false,
        auto_position: false,
        update_campaign_quota: false,
        update_campaign_date: false,
        update_premium_rate: false,
        config_anti_click: false,
        compare_keyword: false,
        buyer_segment: false,
        config_auto_optimize: false,
        openai: false,
        update_target_broad_roi: false,
        update_target_audience: false,
        export_report: false,
        update_pricing_type: false,
        config_audience_auto_cir: false,
        create_tag: false
      },
      form_config_auto_position: {
        keyword: '',
        urls: [],
        placements: [],
        times: [],
        type: 1,
        fromValue: null,
        toValue: null,
        upValue: null,
        downValue: null,
        minValue: null,
        maxValue: null,
        minPrice: null,
        maxPrice: null,
        start_time: '',
        end_time: '',
        stop_action: 0,
        stop_action_2: null,
        stop_action_3: null,
        configStatus: 1,
      },
      form_config_auto_campaign: {
        placements: [],
        times: [],
        start_time: '',
        end_time: '',
        quota_type: 1,
        reduce_value: 1,
        increase_value: 1,
        not_exceed_2: false,
        not_exceed_2_value: 0,
        not_exceed_3: false,
        not_exceed_3_value: 0,
        not_exceed_4: false,
        not_exceed_4_value: 0,
        not_exceed_5: false,
        not_exceed_5_value: 0,
        not_exceed_6: false,
        not_exceed_6_value: 0
      },
      select_multiple: false,
      config_tab: 2,
      selected_time_type: '',
      campaign_time: {
        start_time: null,
        end_time: null
      },
      selected_quota_type: '',
      campaign_quota: {
        quota: null,
        type: 'daily'
      },
      flag_list: this.clone(base_flag),
      metrics: {},
      reports: [],
      default_report: default_report,

      is_compare_keyword: false,
      compare_date_range: [new Date().getTime() - 3600 * 1000 * 24 * 6, new Date().getTime() - 3600 * 1000 * 24],
      compare_metrics: {},
      compare_reports: [],

      picker_options: picker_options,
      compare_data: [],
      compare_segment_data: [],
      compare_auto: null,

      tab: 0,
      enable_buyer_segmentation: false,
      behavior_list: [],
      behavior_segment_id: null,

      form_anti_click: {
        placements: [],
        shop_id: '',
        product_id: '',
        click_number: null,
        order_amount: null,
        ratio: null,
        click_minimum_number: null,
        click_maximum_number: null,
        detect_type: 1,
        detect_value_2: null,
        detect_value_3: null,
        detect_value_4: null,
        type: '2',
        cir: null,
        time_type: 'today',
        start_time: null,
        end_time: null,
        min_cost: null,
        max_cost: null,
        not_order: false,
        not_order_cost: null,
        is_direct_cir: 0
      },
      buyer_segments: [],
      ads_segments: [],
      selected_segment_type_id: null,
      segment_form: {
        segment_1001: [],
        segment_1002: [],
        segment_1003: [],
        segment_3001: []
      },
      form_config_auto_optimize: {
        max_cir: null,
        cir_type: 'board',
        max_base_price: null
      },
      auto_optimize_fixed_list: auto_optimize_fixed_list,

      messages_log: [],
      openai_messages: [],
      openai_message: '',
      show_openai_message: false,
      openai_compare: [new Date().getTime() - 3600 * 1000 * 24 * 6, new Date().getTime() - 3600 * 1000 * 24],
      show_openai_compare: false,

      form_update_target_broad_roi: {
        type: 0,
        custom_type: 'custom',
        custom_type_list: [6.1 * 100000, 9.1 * 100000, 11 * 100000],
        custom_value: null
      },

      show_target_audience: false,
      target_audience_list: [],
      target_audience_form: {
        group_id: null,
        group_name: 'Tệp đối tượng 1',
        age: ['all'],
        gender: 'all',
        buyer: 'all'
      },
      target_audience_premium: null,
      show_target_audience_premium: true,

      updated_base_price: null,

      pricing_type: 1,

      show_banner_duplicate: false,

      form_config_audience_auto_cir: {
        keywords: ['audience'],
        fromCir: 15,
        toCir: 15,
        cirType: 'broad',
        timeType: 'today',
        allowBidPrice: true,
        price: null,
        maxPrice: null,
        allowAtCase1: true,
        case1Type: 'value',
        case1Value: 1,
        case1Reduce: 1,
        case1ReduceMin: null,
        case1Percent: null,
        allowAtCase2: true,
        case2Type: 'stop',
        case2Value: 1,
        case2Reduce: 1,
        case2ReduceMin: 1,
        case2Percent: null,
        case2Min: 20000,
        deleteAntiClick: false,
        configStatus: 1,

        advanced_times: [
          // {advanced_start_time: '00:00', advanced_end_time: '02:00'},
          // {advanced_start_time: '06:00', advanced_end_time: '24:00'}
        ],
        advanced_days: [],
        advanced_day: '',
        advanced_day_number: null,
        advanced_max_value: null,
        advanced_cir: null,
        advanced_cir_type: 'broad',
        advanced_cir_type2: '',
        advanced_price: null,
        advanced_price_type: '',
        advanced_max_price: null,
        advanced_start_price: null,
        advanced_max_cost: null,
        advanced_max_cost_type: 'value',
        advanced_max_cost_value: 600
      },

      product_placement_radio: '',
      product_placement_radio_display: '',

      atosa_flag_list: atosa_flag,

      recommended_list: [],

      keyword_tag_id_selected: null,
      keyword_tag_name: '',
      keyword_tag_list: [],
      keyword_tag_match: [],
      tag_ids_selected: [],

      TARGETING_MIN: null,
      DAILY_BUDGET_MIN: null,
    }
  },

  async beforeMount() {
    if (this.parent_campaign.campaign.type === 'all') {
      this.product_placement_radio = 'all'
      this.product_placement_radio_display = 'all'
    }
    if (this.parent_campaign.campaign.type === 'keyword') {
      this.product_placement_radio = 'search_product'
      this.product_placement_radio_display = 'search_product'
    }
    if (this.parent_campaign.campaign.type === 'targeting') {
      this.product_placement_radio = 'targeting'
      this.product_placement_radio_display = 'targeting'
    }

    await Promise.all([
      this.m__load_campaign_detail(),
      this.m__get_flag_list(),
      this.m__get_keyword_tag(),
      this.m__get_keyword_tag_match()
    ])

    if (this.parent_is_compare_campaign && this.parent_compare_date_range) {
      if (this.parent_compare_date_range[0] && this.parent_compare_date_range[1]) {
        this.compare_date_range = [new Date(this.parent_compare_date_range[0]), new Date(this.parent_compare_date_range[1])]
      }
      await this.m__confirm_compare_keyword()
    }

    if (this.ads_config && this.ads_config.bid_price) {
      this.TARGETING_MIN = this.m__calculate(this.ads_config.bid_price.targeting.min / 100000)
      this.DAILY_BUDGET_MIN = this.m__calculate(this.ads_config.ads_config.product_ads.manual.search_product.min_daily_budget / 100000)
    }
  },

  watch: {
    'start_date': function () {
      this.m__load_campaign_detail()
    },

    'parent_compare_date_range': function () {
      this.compare_date_range = this.parent_compare_date_range
      this.m__confirm_compare_keyword()
    },

    'ads_config': function () {
      // todo: set ads config
      if (this.ads_config && this.ads_config.bid_price) {
        this.TARGETING_MIN = this.m__calculate(this.ads_config.bid_price.targeting.min / 100000)
        this.DAILY_BUDGET_MIN = this.m__calculate(this.ads_config.ads_config.product_ads.manual.search_product.min_daily_budget / 100000)
      }
    }
  },

  computed: {
    c__advertisement_list() {
      const result = this.advertisement_list.filter(i => [2, 5, 8].includes(i.placement)).reverse()

      if (result.find(i => i.placement === 8)) {
        return result
      } else {
        try {
          const summary = {
            placement: null,
            summary: true,
            report: this.clone(this.default_report),
            c_report: this.clone(this.default_report)
          }

          for (const item of result) {
            for (const key of Object.keys(this.default_report)) {
              summary.report[key] += (item.report && item.report[key] ? +item.report[key] : 0)
              summary.c_report[key] += (item.c_report && item.c_report[key] ? +item.c_report[key] : 0)
            }
          }

          for (const key of ['report', 'c_report']) {
            if (summary[key].atosa_cpc) {
              summary[key].atosa_cpc = summary[key].click
                ? this.m__calculate(summary[key].cost / summary[key].click)
                : 0
            }
            if (summary[key].cpm) {
              summary[key].cpm = summary[key].impression
                ? this.m__calculate(summary[key].cost / summary[key].impression * 1000)
                : 0
            }
            if (summary[key].aov) {
              summary[key].aov = summary[key].broad_order
                ? this.m__calculate(summary[key].broad_gmv / summary[key].broad_order)
                : 0
            }
            if (summary[key].ctr) {
              summary[key].ctr = summary[key].impression
                ? summary[key].click / summary[key].impression
                : 0
            }
            if (summary[key].broad_cir) {
              summary[key].broad_cir = summary[key].broad_gmv
                ? summary[key].cost / summary[key].broad_gmv
                : 0
            }
            if (summary[key].direct_cir) {
              summary[key].direct_cir = summary[key].direct_gmv
                ? summary[key].cost / summary[key].direct_gmv
                : 0
            }
            if (summary[key].broad_roi) {
              summary[key].broad_roi = summary[key].cost
                ? summary[key].broad_gmv / summary[key].cost
                : 0
            }
            if (summary[key].direct_roi) {
              summary[key].direct_roi = summary[key].cost
                ? summary[key].direct_gmv / summary[key].cost
                : 0
            }
            if (summary[key].cr) {
              summary[key].cr = summary[key].click
                ? summary[key].broad_order / summary[key].click
                : 0
            }
            if (summary[key].direct_cr) {
              summary[key].direct_cr = summary[key].click
                ? summary[key].direct_order / summary[key].click
                : 0
            }
            if (summary[key].cpc) {
              summary[key].cpc = summary[key].broad_order
                ? summary[key].cost / summary[key].broad_order
                : 0
            }
            if (summary[key].cpdc) {
              summary[key].cpdc = summary[key].broad_order
                ? summary[key].cost / summary[key].direct_order
                : 0
            }
            if (summary[key].cpm) {
              summary[key].cpm = summary[key].impression
                ? this.m__calculate(summary[key].cost / summary[key].impression * 1000)
                : 0
            }
            if (summary[key].cpa) {
              const impression = summary[key].impression ? summary[key].impression : 0
              const ctr = summary[key].ctr ? summary[key].ctr : 0
              const cr = summary[key].cr ? summary[key].cr : 0
              const action = impression * ctr * cr
              summary[key].cpa = action ? this.m__calculate(summary[key].cost / action) : 0
            }
          }

          return [summary, ...result]
        } catch (e) {
          console.error(e)
          return result
        }
      }
    },

    c__campaign_id() {
      if (this.campaign && this.campaign.campaign && this.campaign.campaignid) {
        return this.campaign.campaign.campaignid
      }
      if (this.parent_campaign && this.parent_campaign.campaign && this.parent_campaign.campaign.campaignid) {
        return this.parent_campaign.campaign.campaignid
      }
      return null
    },

    c__flag_list() {
      if (this.is_full) {
        return this.flag_list
      } else {
        return this.clone(this.parent_flag) || []
      }
    }
  },

  methods: {
    async m__create_keyword_tag() {
      if (!this.keyword_tag_name) {
        return
      }

      this.loading.create_tag = true
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/create', {
          name: this.keyword_tag_name,
          color: ''
        }, this.cf())
        await this.m__get_keyword_tag()

        this.loading.create_tag = false
        this.keyword_tag_name = ''
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.create_tag = false
      }
    },

    async m__delete_keyword_tag(tag) {
      try {
        await this.$confirm(this.$t('base.delete_tags_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/delete', {
          _id: tag._id
        }, this.cf())
        await this.m__get_keyword_tag()
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__update_keyword_tag(tag) {
      if (!tag.name || !tag.temp_name) {
        return
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/update', {
          _id: tag._id,
          name: tag.temp_name
        }, this.cf())

        tag.name = tag.temp_name
        tag.editable = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    m__toggle_update_keyword_tag(tag, value) {
      tag.temp_name = tag.name
      tag.editable = value
    },

    m__show_create_tag_dialog() {
      this.show_dialog.create_tag = true
    },

    async m__remove_tag_to_keyword(keyword) {
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/remove_from_keywords', {
          campaign_id: this.c__campaign_id,
          keywords: [keyword.keyword]
        }, this.cf())
        await this.m__get_keyword_tag_match()
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    async m__add_tag_to_keyword(keyword, tag_id) {
      if (!tag_id) {
        return
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/add_to_keywords', {
          tag_id: tag_id,
          campaign_id: this.c__campaign_id,
          keywords: [keyword.keyword]
        }, this.cf())
        await this.m__get_keyword_tag_match()
        this.show_dialog.add_tag_to_keywords = false
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      }
    },

    async m__get_keyword_tag() {
      const response = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/get', this.cf())
      for (const item of response.body.data) {
        item.temp_name = ''
        item.editable = false
      }
      this.keyword_tag_list = response.body.data
    },

    async m__get_keyword_tag_match() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/keyword_tags/get_match', {campaign_id: this.c__campaign_id}, this.cf())
      this.keyword_tag_match = response.body.data
    },

    m__check_keyword_match(keyword, tag_id) {
      const match_found = this.keyword_tag_match.find(i => i.keyword === keyword.keyword)
      return match_found && match_found.tag_id === tag_id
    },

    m__map_keyword_tag(keyword) {
      const match_found = this.keyword_tag_match.find(i => i.keyword === keyword.keyword)
      if (match_found) {
        const tag = this.keyword_tag_list.find(i => i._id === match_found.tag_id)
        return tag ? tag.name : null
      }

      return null
    },

    m__handle_keyword_tag_command(command) {
      const {
        keyword,
        tag_id
      } = JSON.parse(command)
      if (tag_id === 'remove_tag') {
        this.m__remove_tag_to_keyword(keyword)
      } else {
        this.m__add_tag_to_keyword(keyword, tag_id)
      }
    },

    m__check_tag_ids_selected(tag_id) {
      return this.tag_ids_selected.includes(tag_id)
    },

    m__handle_tag_command(command) {
      if (command === 'create_tag') {
        this.m__show_create_tag_dialog()
      } else if (command === 'add_to_keyword') {
        this.m__show_add_tag_to_keyword_dialog()
      } else if (command === 'remove_from_keyword') {
        this.m__remove_tag_to_keywords()
      } else if (command === 'added') {
        this.tag_ids_selected.includes('added') ? this.tag_ids_selected = [] : this.tag_ids_selected = ['added']
      } else if (command === 'not_added') {
        this.tag_ids_selected.includes('not_added') ? this.tag_ids_selected = [] : this.tag_ids_selected = ['not_added']
      } else {
        this.tag_ids_selected = this.tag_ids_selected.filter(i => !['added', 'not_added'].includes(i))
        if (this.m__check_tag_ids_selected(command)) {
          this.tag_ids_selected = this.tag_ids_selected.filter(i => i !== command)
        } else {
          this.tag_ids_selected.push(command)
        }
      }
    },

    m__style_for_summary({row}) {
      if (row.summary) return {'background-color': '#F5F7FA'}
    },

    m__is_show_atosa_index(value) {
      const flag = this.atosa_flag_list.find(i => i.value === value)
      return flag ? flag.checked : false
    },

    async m__set_atosa_flag_list() {
      const flags = this.atosa_flag_list.filter(i => i.checked).map(i => i.value)
      await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_flags/set', {
        shop_id: this.shop._id,
        flags
      }, this.cf())
    },

    async m__get_atosa_flag_list() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_flags/get', {shop_id: this.shop._id}, this.cf())

      if (response.body.data && response.body.data.flags && response.body.data.flags.length) {
        for (const flag of response.body.data.flags) {
          const flag_found = this.atosa_flag_list.find(i => i.value === flag)
          if (flag_found) flag_found.checked = true
        }
      }
    },

    async m__update_config_status(type, status, confirm = true, only_ads = null) {
      try {
        if (confirm) {
          await this.$confirm(this.$t('base.update_config_status_confirm'), this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning'
          })
        }
      } catch (e) {
        return null
      }

      try {
        if (type === 'auto_position') {
          let auto_position_ids = []
          for (const ads of this.c__advertisement_list) {
            if (ads.checked && ads.auto_position) {
              auto_position_ids.push(ads.auto_position.id)
              ads.auto_position.configStatus = status
            }
          }
          if (only_ads && only_ads.auto_position) {
            auto_position_ids = [only_ads.auto_position.id]
            only_ads.auto_position.configStatus = status
          }

          await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_auto_position/status', {
            ids: auto_position_ids,
            status: status,
            mipeeUserId: this.$store.state.userInfo.username
          }, this.cf())
        }

        if (type === 'anti_click') {
          let anti_click_ids = []
          for (const ads of this.c__advertisement_list) {
            if (ads.checked && ads.anti_click) {
              anti_click_ids.push(ads.anti_click.id)
              ads.anti_click.configStatus = status
            }
          }
          if (only_ads && only_ads.anti_click) {
            anti_click_ids = [only_ads.anti_click.id]
            only_ads.anti_click.configStatus = status
          }

          await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_anti_click/status', {
            ids: anti_click_ids,
            status: status,
            mipeeUserId: this.$store.state.userInfo.username
          }, this.cf())
        }

        if (confirm) this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        if (confirm) console.error(e)
        this.ntf_w(e)
      }
    },

    async m__handle_on_off_remove_bulk_configuration(command) {
      if (command === 'auto') await this.m__delete_config_auto_position_multiple()
      if (command === 'anti') await this.m__delete_anti_click_multiple()

      if (command === 'start_auto') await this.m__update_config_status('auto_position', 1)
      if (command === 'start_anti_click') await this.m__update_config_status('anti_click', 1)

      if (command === 'stop_auto') await this.m__update_config_status('auto_position', 0)
      if (command === 'stop_anti_click') await this.m__update_config_status('anti_click', 0)
    },

    async m__handle_bulk_configuration(command) {
      if (command === 'auto') {
        const ads = this.c__advertisement_list.find(i => i.auto_position) || this.c__advertisement_list[0]
        if (ads) {
          this.m__show_config_auto_campaign(ads)
          this.form_config_auto_campaign.placements = this.c__advertisement_list.filter(i => i.checked).map(i => i.placement)
          this.form_config_auto_position.placements = this.c__advertisement_list.filter(i => i.checked).map(i => i.placement)
        }
      }

      if (command === 'anti') {
        const ads = this.c__advertisement_list.find(i => i.anti_click) || this.c__advertisement_list[0]
        if (ads) {
          this.m__show_config_anti_click_single(ads)
          this.form_anti_click.placements = this.c__advertisement_list.filter(i => i.checked).map(i => i.placement)
        }
      }
    },

    m__get_advertisement_list_checked_value() {
      return this.c__advertisement_list.length === this.c__advertisement_list.filter(i => i.checked).length
    },

    m__change_advertisement_list_checked_value(e) {
      for (const ads of this.c__advertisement_list) {
        ads.checked = e
      }
    },

    async m__change_product_placement() {
      try {
        await this.$confirm(this.$t('base.change_placement_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      if (this.product_placement_radio === this.product_placement_radio_display) return

      const form = {
        campaign_id: this.c__campaign_id,
        change_product_placement: {
          product_placement: this.product_placement_radio
        },
        header: {},
        type: 'change_product_placement'
      }

      if (this.parent_campaign.campaign.bidding_type === 'manual') {
        const placement0 = this.campaign.advertisements.find(i => i.placement === 0)
        const placement2 = this.campaign.advertisements.find(i => i.placement === 2)
        const placement5 = this.campaign.advertisements.find(i => i.placement === 5)

        let keyword_list = []
        if (placement0 && placement0.extinfo.keywords.length) {
          keyword_list = placement0.extinfo.keywords.filter(i => i.status === 1).map(i => ({
            keyword: i.keyword,
            bid_price: i.price * 100000,
            match_type: i.match_type === 0 ? 'exact' : 'broad'
          }))
        } else {
          const suggest_keyword_response = await this.sp_user.marketing_suggest_keyword(placement0.itemid)
          const shopee_suggest_keywords = suggest_keyword_response.data
          const keyword = {
            keyword: shopee_suggest_keywords[0] ? shopee_suggest_keywords[0].keyword : `${this.$t('base.keyword')} 1`,
            bid_price: shopee_suggest_keywords[0] ? +shopee_suggest_keywords[0].recommend_price * 100000 : this.TARGETING_MIN * 100000,
            match_type: 'broad'
          }
          keyword_list = [keyword]
        }

        const display_location = {
          daily_discover: {},
          you_may_also_like: {}
        }
        if (placement2) {
          display_location.daily_discover = {
            bid_price: +placement2.extinfo.target.price * 100000,
            state: 'active'
          }
        } else {
          display_location.daily_discover = {
            bid_price: this.TARGETING_MIN * 100000,
            state: 'active'
          }
        }
        if (placement5) {
          display_location.you_may_also_like = {
            bid_price: +placement5.extinfo.target.price * 100000,
            state: 'active'
          }
        } else {
          display_location.you_may_also_like = {
            bid_price: this.TARGETING_MIN * 100000,
            state: 'active'
          }
        }

        if (this.product_placement_radio === 'all' && this.product_placement_radio_display === 'targeting') {
          form.change_product_placement['keyword_list'] = keyword_list
        }
        if (this.product_placement_radio === 'all' && this.product_placement_radio_display === 'search_product') {
          form.change_product_placement['display_location'] = display_location
        }
        if (this.product_placement_radio === 'search_product' && this.product_placement_radio_display === 'targeting') {
          form.change_product_placement['keyword_list'] = keyword_list
        }
        if (this.product_placement_radio === 'targeting' && this.product_placement_radio_display === 'search_product') {
          form.change_product_placement['display_location'] = display_location
        }
      }

      console.log(form)
      const update_response = await this.sp_user.marketing_pas_update_campaign(form)
      console.log(update_response)
      this.$emit('change_product_placement', {
        campaign_id: this.c__campaign_id,
        new_type: this.product_placement_radio
      })
    },

    m__check_config_status(data) {
      return data.configStatus !== 0
    },

    async m__delete_audience_auto_cir() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/audience_auto_cir/delete', {
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          shopId: this.shop._id,
          keywords: ['audience']
        }, this.cf())

        const [keyword] = this.target_audience_list
        if (keyword) {
          keyword.auto_cir = null
        }

        this.ntf_s(this.$t('base.delete_config_success'))
        this.show_dialog.config_audience_auto_cir = false
      } catch (e) {
        this.ntf_w(e)
      }
    },

    async m__confirm_save_audience_auto_cir() {
      if (!this.form_config_audience_auto_cir.fromCir) {
        this.ntf_w(this.$t('required.expected_cir'))
        return
      }

      if (!this.form_config_audience_auto_cir.toCir) {
        this.ntf_w(this.$t('required.expected_cir'))
        return
      }

      if (!this.form_config_audience_auto_cir.cirType) {
        this.ntf_w(this.$t('required.cir_type'))
        return
      }

      if (!this.form_config_audience_auto_cir.timeType) {
        this.ntf_w(this.$t('required.check_duration'))
        return
      }

      if (this.form_config_audience_auto_cir.allowBidPrice) {
        if (!this.form_config_audience_auto_cir.price) {
          this.ntf_w(this.$t('required.bonus_premium_rate'))
          return
        }
        if (!this.form_config_audience_auto_cir.maxPrice) {
          this.ntf_w(this.$t('required.max_premium_rate'))
          return
        }
      }

      if (this.form_config_audience_auto_cir.allowAtCase1) {
        if (this.form_config_audience_auto_cir.case1Type === 'value' && !this.form_config_audience_auto_cir.case1Value) {
          this.ntf_w(this.$t('required.premium_rate'))
          return
        }
        if (this.form_config_audience_auto_cir.case1Type === 'reduce' && !this.form_config_audience_auto_cir.case1Reduce) {
          this.ntf_w(this.$t('required.premium_rate'))
          return
        }
        if (this.form_config_audience_auto_cir.case1Type === 'reduce' && !this.form_config_audience_auto_cir.case1ReduceMin) {
          this.ntf_w(this.$t('required.min_premium_rate'))
          return
        }
        if (this.form_config_audience_auto_cir.case1Type === 'percent' && !this.form_config_audience_auto_cir.case1Percent) {
          this.ntf_w(this.$t('required.percent'))
          return
        }
      }

      if (this.form_config_audience_auto_cir.allowAtCase2) {
        if (this.form_config_audience_auto_cir.case2Type === 'value' && !this.form_config_audience_auto_cir.case2Value) {
          this.ntf_w(this.$t('required.premium_rate'))
          return
        }
        if (this.form_config_audience_auto_cir.case2Type === 'percent' && !this.form_config_audience_auto_cir.case2Percent) {
          this.ntf_w(this.$t('required.percent'))
          return
        }
        if (this.form_config_audience_auto_cir.case2Type === 'reduce' && !this.form_config_audience_auto_cir.case2ReduceMin) {
          this.ntf_w(this.$t('required.min_premium_rate'))
          return
        }
        if (this.form_config_audience_auto_cir.case2Type === 'percent' && !this.form_config_audience_auto_cir.case2Percent) {
          this.ntf_w(this.$t('required.percent'))
          return
        }
      }

      if (!this.form_config_audience_auto_cir.allowBidPrice && !this.form_config_audience_auto_cir.allowAtCase1 && !this.form_config_audience_auto_cir.allowAtCase2) {
        this.ntf_w(this.$t('required.must_select_at_least'))
        return
      }

      try {
        await this.$confirm(this.$t('ads.just_select_only_one_1'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.config_audience_auto_cir = true
      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/audience_auto_cir', {
          ...this.form_config_audience_auto_cir,
          advancedDays: this.form_config_audience_auto_cir.advanced_days.map(i => JSON.stringify(i)),
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          shopId: this.shop._id,
          configStatus: 1
        }, this.cf())

        const [keyword] = this.target_audience_list
        if (keyword) {
          keyword.auto_cir = {
            ...this.form_config_audience_auto_cir,
            advancedDays: this.form_config_audience_auto_cir.advanced_days.map(i => JSON.stringify(i)),
            configStatus: 1
          }
        }

        this.ntf_s(this.$t('base.save_config_success'))
        this.show_dialog.config_audience_auto_cir = false
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.config_audience_auto_cir = false
      }
    },

    m__show_config_audience_auto_cir() {
      const [keyword] = this.target_audience_list

      if (keyword.auto_cir) {
        Object.assign(this.form_config_audience_auto_cir, this.clone(keyword.auto_cir))
        this.form_config_audience_auto_cir.advanced_days = this.form_config_audience_auto_cir.advancedDays
          ? this.form_config_audience_auto_cir.advancedDays.map(i => JSON.parse(i))
          : []
      }

      this.show_dialog.config_audience_auto_cir = true
      this.config_tab = 6
    },

    m__open_duplicate_link() {
      // const url = this.$route.path + `?shop_id=${this.shop.shop_id}&search=${this.parent_campaign.product.itemid}`
      const url = `/marketing/pas?shop_id=${this.shop.shop_id}&search=${this.parent_campaign.product.itemid}`
      window.open(url, '_blank')
    },

    async m__confirm_update_base_price(data, index) {
      if (!+this.updated_base_price) {
        return
      }

      if (+this.updated_base_price < this.TARGETING_MIN) {
        this.ntf_w(this.$t('base.y_gte_than_x', {
          y: this.$t('base.bid_price'),
          x: this.TARGETING_MIN
        }))
        return
      }

      let placement = ''
      if (data.placement === 2) placement = 'daily_discover'
      if (data.placement === 5) placement = 'you_may_also_like'
      const body = {
        campaign_id: this.c__campaign_id,
        type: 'change_display_location',
        header: {},
        change_display_location: {
          bid_price: +this.updated_base_price * 100000,
          place: placement,
          state: data.status === 1 ? 'active' : 'inactive'
        }
      }

      data.extinfo.target.price = +this.updated_base_price
      await this.sp_user.marketing_pas_update_campaign(body)
      this.ntf_s(this.$t('base.update_data_success'))

      console.log(this.$refs['popover-ads-' + index])
      console.log(this.$refs['popover-ads-' + index].doClose)
      this.$refs['popover-ads-' + index].showPopper = false
      this.$refs['popover-ads-' + index].doClose()
    },

    async m__confirm_update_target_audience_premium(data, index) {
      if (!this.target_audience_premium) {
        return
      }

      if (this.target_audience_premium < 10) {
        this.ntf_w(this.$t('required.min_premium_rate_is_x', {x: '10%'}))
        return
      }

      if (this.target_audience_premium > 400) {
        this.ntf_w(this.$t('required.max_premium_rate_is_x', {x: '10%'}))
        return
      }

      const body = {
        campaign_id: this.c__campaign_id,
        group_id: data.group_id,
        header: {},
        action: 'change_premium_rate',
        change_premium_rate: {
          premium_rate: this.target_audience_premium * 1000
        }
      }
      await this.sp_user.marketing_pas_update_campaign_target_audience(body)

      data.premium_rate = this.target_audience_premium * 1000
      this.show_target_audience_premium = false
      this.ntf_s(this.$t('base.update_data_success'))

      this.$refs['popover-audience-' + index].doClose()
    },

    async m__confirm_update_target_audience() {
      if (!this.target_audience_form.group_name) {
        this.ntf_w(this.$t('required.audience_group_name'))
        return
      }

      this.loading.update_target_audience = true

      if (this.target_audience_form.group_id) {
        const body = {
          campaign_id: this.c__campaign_id,
          group_id: this.target_audience_form.group_id,
          header: {},
          log_key: '',
          action: 'change_group',
          change_group: {
            group_name: this.target_audience_form.group_name,
            option_list: []
          }
        }
        body.change_group.option_list.push({
          option: 'age',
          tag_id_list: this.target_audience_form.age.includes('all') ? null : this.target_audience_form.age.map(i => this.m__map_audience_tag_id(i))
        })
        body.change_group.option_list.push({
          option: 'gender',
          tag_id_list: this.target_audience_form.gender === 'all' ? null : [this.m__map_audience_tag_id(this.target_audience_form.gender)]
        })
        body.change_group.option_list.push({
          option: 'buyer',
          tag_id_list: this.target_audience_form.buyer === 'all' ? null : [this.m__map_audience_tag_id(this.target_audience_form.buyer)]
        })
        await this.sp_user.marketing_pas_update_campaign_target_audience(body)
      } else {
        const body = {
          campaign_id: this.c__campaign_id,
          group_id: 0,
          header: {},
          log_key: make_uuid(),
          action: 'create_group',
          create_group: {
            group_name: this.target_audience_form.group_name,
            option_list: [],
            premium_rate: 15000
          }
        }
        body.create_group.option_list.push({
          option: 'age',
          tag_id_list: this.target_audience_form.age.includes('all') ? null : this.target_audience_form.age.map(i => this.m__map_audience_tag_id(i))
        })
        body.create_group.option_list.push({
          option: 'gender',
          tag_id_list: this.target_audience_form.gender === 'all' ? null : [this.m__map_audience_tag_id(this.target_audience_form.gender)]
        })
        body.create_group.option_list.push({
          option: 'buyer',
          tag_id_list: this.target_audience_form.buyer === 'all' ? null : [this.m__map_audience_tag_id(this.target_audience_form.buyer)]
        })
        await this.sp_user.marketing_pas_update_campaign_target_audience(body)
      }

      const start_time = this.dayjs(this.start_date).startOf('day')
      const end_time = this.dayjs(this.end_date).endOf('day')
      await this.m__get_campaign_target_audience(start_time, end_time)

      this.show_dialog.update_target_audience = false
      this.ntf_s(this.$t('base.update_data_success'))

      this.loading.update_target_audience = false
    },

    m__show_update_target_audience_dialog(data) {
      if (data) {
        this.target_audience_form.group_id = data.group_id
        this.target_audience_form.group_name = data.group_name

        const age = data.option_list.find(i => i.option === 'age')
        if (age) {
          if (age.tag_list && age.tag_list.length) {
            this.target_audience_form.age = age.tag_list.map(i => i.tag_name)
          } else {
            this.target_audience_form.age = ['all']
          }
        }

        const gender = data.option_list.find(i => i.option === 'gender')
        if (gender) {
          if (gender.tag_list && gender.tag_list.length) {
            this.target_audience_form.gender = gender.tag_list[0].tag_name
          } else {
            this.target_audience_form.gender = 'all'
          }
        }

        const buyer = data.option_list.find(i => i.option === 'buyer')
        if (buyer) {
          if (buyer.tag_list && buyer.tag_list.length) {
            this.target_audience_form.buyer = buyer.tag_list[0].tag_name
          } else {
            this.target_audience_form.buyer = 'all'
          }
        }
      }

      this.show_dialog.update_target_audience = true
    },

    m__map_audience_tag_id(tag_name) {
      if (tag_name === 'age__18_24') return 101001
      if (tag_name === 'age__25_34') return 101002
      if (tag_name === 'age__35_plus') return 101003
      if (tag_name === 'gender__men') return 102002
      if (tag_name === 'gender__women') return 102001
      if (tag_name === 'buyer__new') return 203001
    },

    m__map_audience_tag_name(data, key) {
      const found = data.option_list.find(i => i.option === key)
      if (!found) return ''

      if (!found.tag_list) return 'Tất cả'

      return found.tag_list.map(i => {
        if (i.tag_name === 'age__18_24') return '18-24'
        if (i.tag_name === 'age__25_34') return '25-34'
        if (i.tag_name === 'age__35_plus') return '35+'
        if (i.tag_name === 'gender__men') return this.$t('base.men')
        if (i.tag_name === 'gender__women') return this.$t('base.women')
        if (i.tag_name === 'buyer__new') return this.$t('base.potential_new_buyers')

        return i.tag_name
      }).join(',')
    },

    async m__confirm_update_target_audience_status(data, status) {
      await this.sp_user.marketing_pas_update_campaign_target_audience({
        action: status,
        campaign_id: this.c__campaign_id,
        group_id: data.group_id,
        header: {}
      })

      data.status = status + 'd'
    },

    async m__get_campaign_target_audience(start_time, end_time) {
      const response = await this.sp_user.marketing_pas_get_campaign_target_audience(this.c__campaign_id)
      for (const item of response.data.group_list) {
        const new_response = await this.sp_user.marketing_get_report('audience_group', 'product', start_time.unix(), end_time.unix(), {campaign_id: this.c__campaign_id})
        const report_response = this.m__map_search_report_by_key(new_response)

        item.report = report_response.data ? report_response.data.find(i => i.keyword === item.group_id.toString()) : null
        item.c_report = {...this.default_report}
        item.auto_cir = null

        this.$http.get(this.API.URL_API_SRV_1 + '/audience_auto_cir', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: this.c__campaign_id
          }
        }).then(response => {
          if (response.body.length) {
            item.auto_cir = response.body[0]
          }
        })
      }

      this.target_audience_list = response.data.group_list
    },

    async m__confirm_update_pricing_type() {
      this.loading.update_pricing_type = true

      await this.sp_user.marketing_pas_update_campaign({
        campaign_id: this.c__campaign_id,
        change_ecpc: {
          ecpc: this.pricing_type === 2
        },
        type: 'change_ecpc',
        header: {}
      })

      for (const ads of this.campaign.advertisements) {
        ads.extinfo.pricing_type = this.pricing_type
      }

      this.show_dialog.update_pricing_type = false
      this.loading.update_pricing_type = false
    },

    m__has_pricing_type() {
      return this.campaign && this.campaign.advertisements && this.campaign.advertisements.some(i => [0, 1, 2, 5].includes(i.placement))
    },

    m__get_pricing_type() {
      return this.campaign && this.campaign.advertisements && this.campaign.advertisements.some(i => [0, 1, 2, 5].includes(i.placement)) &&
        this.campaign.advertisements[0].extinfo.pricing_type
    },

    m__show_update_pricing_type() {
      this.pricing_type = this.campaign.advertisements[0].extinfo.pricing_type
      this.show_dialog.update_pricing_type = true
    },

    async m__confirm_update_target_broad_roi() {
      this.loading.update_target_broad_roi = true

      // todo: edit roi two
      if (this.parent_campaign.campaign.bidding_type === 'roi_two') {
        let target_roi_two = this.form_update_target_broad_roi.type === 'custom'
          ? this.form_update_target_broad_roi.custom_type
          : 0

        if (this.form_update_target_broad_roi.type === 'custom' && this.form_update_target_broad_roi.custom_type === 'custom') {
          target_roi_two = +this.form_update_target_broad_roi.custom_value * 100000
          if (!target_roi_two) target_roi_two = 0

          if (!target_roi_two || Number.isNaN(target_roi_two)) {
            this.ntf_w(this.$t('required.target_broad_roi'))
            this.loading.update_target_broad_roi = false
            return
          }
        }

        const response = await this.sp_user.marketing_pas_update_campaign({
          campaign_id: this.c__campaign_id,
          header: {},
          reference_id: make_uuid(),
          type: 'change_roi_two_target',
          change_roi_two_target: {
            log_key: null,
            target_value: target_roi_two
          }
        })
        if (response && response.code === 0) {
          this.campaign.campaign.roi_two.target = target_roi_two
          this.parent_campaign.campaign.roi_two_target = parseFloat((target_roi_two / 100000).toFixed(1))
        }
      }
      // todo: end edit roi two

      // todo: edit auto
      if (this.parent_campaign.campaign.bidding_type === 'auto') {
        let target_broad_roi = this.form_update_target_broad_roi.type === 'auto'
          ? 0
          : this.form_update_target_broad_roi.custom_type

        if (this.form_update_target_broad_roi.type === 'custom' && this.form_update_target_broad_roi.custom_type === 'custom') {
          target_broad_roi = +this.form_update_target_broad_roi.custom_value * 100000
          if (!target_broad_roi) target_broad_roi = 0
        }

        target_broad_roi = +target_broad_roi

        await this.sp_user.marketing_pas_update_campaign({
          campaign_id: this.c__campaign_id,
          header: {},
          type: 'change_target_broad_roi',
          change_target_broad_roi: {
            log_key: 'target_roi_log:product_manual:' + make_uuid(),
            target_broad_roi: target_broad_roi
          }
        })

        if (this.campaign && this.campaign.advertisements && this.campaign.advertisements.length) {
          this.campaign.advertisements[0].extinfo.target_broad_roi = target_broad_roi
        }
      }
      // todo: end edit auto

      this.show_dialog.update_target_broad_roi = false
      this.loading.update_target_broad_roi = false
    },

    m__has_target_broad_roi() {
      return this.campaign && this.campaign.campaign && this.campaign.campaign.bidding_strategy === 'roi_two'
    },

    m__show_update_target_broad_roi_dialog() {
      Object.assign(this.form_update_target_broad_roi, {
        type: 0,
        custom_type: 'custom',
        custom_value: null
      })

      if (this.campaign && this.campaign.campaign && this.campaign.campaign.roi_two) {
        const {target} = this.campaign.campaign.roi_two
        this.form_update_target_broad_roi.type = target ? 'custom' : 'auto'
        if (this.form_update_target_broad_roi.custom_type_list.includes(target)) {
          this.form_update_target_broad_roi.custom_type = target
        } else {
          this.form_update_target_broad_roi.custom_type = 'custom'
          this.form_update_target_broad_roi.custom_value = target / 100000
        }
        this.show_dialog.update_target_broad_roi = true
      }
    },

    m__get_target_broad_roi() {
      if (this.campaign && this.campaign.advertisements && this.campaign.advertisements.length) {
        return this.campaign.advertisements[0].extinfo.target_broad_roi
          ? (+this.campaign.advertisements[0].extinfo.target_broad_roi / 100000).toFixed(1)
          : this.$t('ads.auto_bidding')
      } else {
        return ''
      }
    },

    m__back_to_list() {
      this.$emit('back_to_list')
    },

    async m__delete_config_auto_optimize() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
      } catch (e) {
        return
      }

      try {
        await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_auto_optimize', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: this.c__campaign_id,
            placement: this.selected_ads.placement
          }
        })

        this.selected_ads.auto_optimize = null
        this.ntf_s(this.$t('base.delete_config_success'))
      } catch (e) {
        console.error(e)
      }
    },

    async m__update_config_auto_optimize() {
      if (!this.form_config_auto_optimize.max_cir) {
        return this.ntf_w(this.$t('required.expected_cir'))
      }

      if (!this.form_config_auto_optimize.max_base_price) {
        return this.ntf_w(this.$t('required.max_bid_price'))
      }

      try {
        await this.$confirm(this.$t('base.save_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
      } catch (e) {
        return
      }

      this.loading.config_auto_optimize = true
      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_auto_optimize', {
          shopId: this.shop._id,
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          placement: this.selected_ads.placement,
          maxCir: this.form_config_auto_optimize.max_cir,
          cirType: this.form_config_auto_optimize.cir_type,
          maxBasePrice: this.form_config_auto_optimize.max_base_price
        }, this.cf())

        this.selected_ads.auto_optimize = {
          maxCir: this.form_config_auto_optimize.max_cir,
          cirType: this.form_config_auto_optimize.cir_type,
          maxBasePrice: this.form_config_auto_optimize.max_base_price
        }

        this.show_dialog.config_auto_optimize = false
        this.ntf_s(this.$t('base.save_config_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.config_auto_optimize = false
      }
    },

    m__show_config_auto_optimize(ads) {
      this.selected_ads = ads

      if (ads.auto_optimize) {
        this.form_config_auto_optimize = {
          max_cir: ads.auto_optimize.maxCir,
          cir_type: ads.auto_optimize.cirType,
          max_base_price: ads.auto_optimize.maxBasePrice
        }
      }

      this.show_dialog.config_auto_optimize = true
    },

    async m__update_buyer_segments() {
      this.loading.buyer_segment = true

      try {
        const form = {
          campaignid: this.c__campaign_id,
          segments: [
            {
              segment_cluster_id: [],
              segment_type_id: this.selected_segment_type_id
            }
          ]
        }
        if (this.selected_segment_type_id === 1003) {
          const buyer_segment_found = this.buyer_segments.find(i => i.segment_type.segment_type_id === 1003)
          for (const id of this.segment_form[`segment_1003`]) {
            const segment_cluster_found = buyer_segment_found.segment_clusters.find(i => i.segment_display_cluster.segment_cluster_id === id)
            form.segments[0].segment_cluster_id.push(...segment_cluster_found.child_clusters.map(i => i.segment_display_cluster.segment_cluster_id))
          }
        } else {
          form.segments[0].segment_cluster_id.push(...this.segment_form[`segment_${this.selected_segment_type_id}`])
        }

        await this.sp_user.targeting_marketing_update_segment(form)
        await this.m__load_campaign_detail(false)
        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.buyer_segment = false
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      } finally {
        this.loading.buyer_segment = false
      }
    },

    async m__save_update_price_log(old_ads, type, placement) {
      const start_time = this.dayjs().startOf('day')
      const end_time = this.dayjs().endOf('day')

      const [campaign_report_resp, ads_report_resp, shop_report_resp, ads_report_resp_v2, campaign_report_resp_v2] = await Promise.all([
        {data: null},
        {data: null},
        this.sp_user.dashboard__key_metrics(start_time.unix(), end_time.unix(), 'real_time'),
        {data: null},
        {data: null}
        // this.sp_user.marketing_get_time_graph('targeting', start_time.unix(), end_time.unix(), {}),
        // this.sp_user.marketing_get_time_graph('targeting', start_time.unix(), start_time.unix(), {campaign_id: this.c__campaign_id})
      ])

      const form = {
        mipeeUserId: this.$store.state.userInfo.username,
        campaignId: this.c__campaign_id,
        type: type,
        placement: placement,
        oldAds: JSON.stringify(old_ads),
        newAds: JSON.stringify(this.advertisement_list),
        shopMetrics: JSON.stringify(shop_report_resp.result),
        adsMetrics: ads_report_resp.data ? JSON.stringify(ads_report_resp.data.data) : '',
        campaignReport: campaign_report_resp.data ? JSON.stringify(campaign_report_resp.data.data) : '',
        adsMetricsV2: ads_report_resp_v2.data ? JSON.stringify(ads_report_resp_v2.data) : '',
        campaignReportV2: campaign_report_resp_v2.data ? JSON.stringify(campaign_report_resp_v2.data) : ''
      }
      this.$http.post(this.API.URL_API_SRV_1 + '/lg/3.1', form, this.cf()).catch(console.error)
    },

    m__show_config_anti_click_single(ads) {
      if (!this.check_role(this.shop, 'targeting_ads', 'anti_click')) {
        return
      }

      this.form_anti_click.placements = [ads.placement]

      if (ads.anti_click) {
        this.form_anti_click.ratio = ads.anti_click.ratio
        this.form_anti_click.click_number = ads.anti_click.clickNumber
        this.form_anti_click.order_amount = ads.anti_click.orderAmount
        this.form_anti_click.click_minimum_number = ads.anti_click.clickMinimumNumber
        this.form_anti_click.click_maximum_number = ads.anti_click.clickMaximumNumber
        this.form_anti_click.detect_type = ads.anti_click.detectType
        // this.form_anti_click.detect_type = 1
        this.form_anti_click.detect_value_2 = ads.anti_click.detectValue2
        this.form_anti_click.detect_value_3 = ads.anti_click.detectValue3
        this.form_anti_click.type = ads.anti_click.ratio ? '1' : '2'
        this.form_anti_click.cir = ads.anti_click.cir
        this.form_anti_click.time_type = ads.anti_click.timeType || 'today'
        this.form_anti_click.start_time = ads.anti_click.startTime ? new Date(keyword.anti_click.startTime) : null
        this.form_anti_click.end_time = ads.anti_click.endTime ? new Date(keyword.anti_click.endTime) : null
        this.form_anti_click.min_cost = ads.anti_click.minCost
        this.form_anti_click.max_cost = ads.anti_click.maxCost
        this.form_anti_click.not_order = !!ads.anti_click.minCost
        this.form_anti_click.is_direct_cir = ads.anti_click.isDirectCir || 0
      }

      this.selected_ads = ads
      this.show_dialog.config_anti_click = true
      this.config_tab = 4
    },

    async m__delete_anti_click_multiple() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.delete'),
          cancelButtonText: this.$t('base.cancel')
        })
      } catch (e) {
        return
      }

      try {
        for (const ads of this.c__advertisement_list.filter(i => i.checked)) {
          await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_anti_click', {
            ...this.cf(),
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: this.c__campaign_id,
              placement: ads.placement
            }
          })
          ads.anti_click = null
        }

        this.ntf_s(this.$t('base.delete_success'))
        this.show_dialog.config_anti_click = false
      } catch (e) {
      }
    },

    async m__delete_anti_click_single() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.delete'),
          cancelButtonText: this.$t('base.cancel')
        })

        await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_anti_click', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: this.c__campaign_id,
            placement: this.selected_ads.placement
          }
        })
        this.selected_ads.anti_click = null

        this.ntf_s(this.$t('base.delete_success'))
        this.show_dialog.config_anti_click = false
      } catch (e) {
      }
    },

    async m__confirm_anti_click_single() {
      try {
        if (this.form_anti_click.type === '1') {
          if (!this.form_anti_click.ratio || this.form_anti_click.ratio < 0) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.expected_cir'),
              x: '0'
            }))
            return
          }

          if (!this.form_anti_click.click_minimum_number || this.form_anti_click.click_minimum_number < 1) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.min_clicks'),
              x: '0'
            }))
            return
          }

          if (!this.form_anti_click.click_maximum_number || this.form_anti_click.click_maximum_number < 1) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.max_clicks'),
              x: '0'
            }))
            return
          }
        } else {
          if (!this.form_anti_click.cir || this.form_anti_click.cir < 0) {
            this.ntf_w(this.$t('base.y_gt_x', {
              y: this.$t('base.ratio'),
              x: '0'
            }))
            return
          }

          if (this.form_anti_click.time_type === 'custom') {
            if (!this.form_anti_click.start_time) {
              this.ntf_w(this.$t('required.start_time'))
              return
            }
            if (!this.form_anti_click.end_time) {
              this.ntf_w(this.$t('required.end_time'))
              return
            }
          }
        }

        if (this.form_anti_click.detect_type === 2 && !this.form_anti_click.detect_value_2) {
          this.ntf_w(this.$t('required.percent'))
          return
        }

        if (this.form_anti_click.detect_type === 3 && !this.form_anti_click.detect_value_3) {
          this.ntf_w(this.$t('required.bid_price'))
          return
        }

        if (this.form_anti_click.not_order && (!this.form_anti_click.min_cost || this.m__calculate(this.form_anti_click.min_cost) === 0)) {
          this.ntf_w(this.$t('required.max_cost_if_gmv_by_0'))
          return
        }

        if (this.form_anti_click.not_order && !this.form_anti_click.min_cost) {
          await this.$confirm(this.$t('ads.anti_click_label.confirm_1'), this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning'
          })
        } else if (this.form_anti_click.not_order && this.form_anti_click.min_cost < 1000) {
          await this.$confirm(this.$t('ads.anti_click_label.confirm_2'), this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning'
          })
        }

        this.loading.config_anti_click = true

        const form = {
          placements: this.form_anti_click.placements,
          shopId: this.shop._id,
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          clickNumber: this.form_anti_click.click_number,
          orderAmount: this.form_anti_click.order_amount,
          ratio: this.form_anti_click.type === '1' ? this.form_anti_click.ratio : null,
          clickMinimumNumber: this.form_anti_click.click_minimum_number,
          clickMaximumNumber: this.form_anti_click.click_maximum_number,
          detectType: this.form_anti_click.detect_type,
          detectValue2: this.form_anti_click.detect_value_2,
          detectValue3: this.form_anti_click.detect_value_3,
          cir: this.form_anti_click.type === '2' ? this.form_anti_click.cir : null,
          timeType: this.form_anti_click.time_type,
          startTime: this.form_anti_click.start_time ? this.dayjs(this.form_anti_click.start_time).toISOString() : '',
          endTime: this.form_anti_click.end_time ? this.dayjs(this.form_anti_click.end_time).toISOString() : '',
          minCost: this.form_anti_click.not_order ? (this.form_anti_click.min_cost || 0) : null,
          maxCost: this.form_anti_click.max_cost,
          isDirectCir: this.form_anti_click.is_direct_cir
        }

        await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_anti_click', form)

        for (const placement of this.form_anti_click.placements) {
          const ads = this.advertisement_list.find(i => i.placement === placement)
          ads.anti_click = {
            ratio: this.form_anti_click.ratio,
            clickNumber: this.form_anti_click.click_number,
            orderAmount: this.form_anti_click.order_amount,
            clickMinimumNumber: this.form_anti_click.click_minimum_number,
            clickMaximumNumber: this.form_anti_click.click_maximum_number,
            detectType: this.form_anti_click.detect_type,
            detectValue2: this.form_anti_click.detect_value_2,
            detectValue3: this.form_anti_click.detect_value_3,
            cir: this.form_anti_click.type === '2' ? this.form_anti_click.cir : null,
            timeType: this.form_anti_click.time_type,
            startTime: this.form_anti_click.start_time ? this.dayjs(this.form_anti_click.start_time).toISOString() : '',
            endTime: this.form_anti_click.end_time ? this.dayjs(this.form_anti_click.end_time).toISOString() : '',
            minCost: this.form_anti_click.not_order ? (this.form_anti_click.min_cost || 0) : null,
            maxCost: this.form_anti_click.max_cost,
            isDirectCir: this.form_anti_click.is_direct_cir,
            createdAt: new Date()
          }
        }

        this.ntf_s(this.$t('base.save_config_success'))
        this.show_dialog.config_anti_click = false
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.config_anti_click = false
      }
    },

    async m__change_all_segment(action) {
      for (const i of this.behavior_list) {
        i.enabled = action === 'enable'
      }

      await this.m__change_segment()
    },

    async m__change_segment() {
      try {
        const form = {
          campaignid: this.c__campaign_id,
          segments: [{
            segment_cluster_id: this.behavior_list.filter(i => i.enabled).map(i => i.segment_cluster_id),
            segment_type_id: this.behavior_segment_id
          }]
        }

        await this.sp_user.targeting_marketing_update_segment(form)
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    m__time_to_text(item) {
      const start_hour = item.start_time.split(':')[0]
      const start_minute = item.start_time.split(':')[1]

      const end_hour = item.end_time.split(':')[0]
      const end_minute = item.end_time.split(':')[1]

      const start_time = this.dayjs().hour(start_hour).minute(start_minute).minute(0)
      const end_time = this.dayjs().hour(end_hour).minute(end_minute).minute(0)

      if (start_time.isBefore(end_time, 'second')) {
        return `${this.$t('base.starting_at')} ${start_hour} ${this.$t('base.hours')} ${start_minute} ${this.$t('base.minutes')} ${this.$t('base.to')} ${end_hour} ${this.$t('base.hours')} ${end_minute} ${this.$t('base.minutes')}`
      } else {
        return `${this.$t('base.starting_at')} ${start_hour} ${this.$t('base.hours')} ${start_minute} ${this.$t('base.minutes')} ${this.$t('base.to')} ${end_hour} ${this.$t('base.hours')} ${end_minute} ${this.$t('base.minutes')} ${this.$t('base.the_next_day')}`
      }
    },

    async m__confirm_compare_keyword() {
      this.loading.compare_keyword = true
      this.is_compare_keyword = false

      const agg_type = this.campaign.advertisements.some(i => [1, 2, 5].includes(i.placement))
        ? 'display_location'
        : 'product_placement_auto_strategy'
      const start_time = this.dayjs(new Date(this.compare_date_range[0])).startOf('d')
      const end_time = this.dayjs(new Date(this.compare_date_range[1])).endOf('d')
      const new_response = await this.sp_user.marketing_get_report(agg_type, 'product', start_time.unix(), end_time.unix(), {campaign_id: this.c__campaign_id})
      this.compare_data = this.m__map_targeting_report_by_key(new_response) || []
      // this.compare_data = await this.sp_user.target_marketing_get_report_v2(this.c__campaign_id, this.campaign.product.itemid, start_time.unix(), end_time.unix())
      for (const ads of this.advertisement_list) {
        let compare_report = this.compare_data.find(i => i.placement === ads.placement.toString())
        if (compare_report) {
          ads.c_report = this.m__map_detail_campaign_report(compare_report)
        } else {
          ads.c_report = {...this.default_report}
        }
      }
      if (this.enable_buyer_segmentation) {
        const segment_report_resp = await this.sp_user.targeting_marketing_item_report_by_segments(start_time.unix(), end_time.unix(), this.campaign.product.itemid)
        if (segment_report_resp.data) {
          this.compare_segment_data = segment_report_resp.data
          for (const row of this.behavior_list) {
            const compare_segment_report = this.compare_segment_data.find(i => i.segment_cluster_id === row.segment_cluster_id)
            if (compare_segment_report) {
              row.c_report = this.m__map_detail_campaign_report(compare_segment_report)
            } else {
              row.c_report = {...this.default_report}
            }
          }
        }
      }

      const graph_response = await this.sp_user.marketing_get_time_graph('product', this.dayjs(start_time).startOf('day').unix(), this.dayjs(end_time).endOf('day').unix(), {campaign_id: this.c__campaign_id})
      if (!graph_response.data) {
        this.loading.compare_campaign = false
        return
      }
      this.compare_metrics = this.m__map_graph_response(graph_response.data.report_aggregate)
      this.compare_reports = this.m__map_graph_by_time_response(graph_response.data.report_by_time)

      // const metrics = {}
      //
      // const resp = await this.sp_user.marketing_detail_report_by_time_v2(this.c__campaign_id, start_time.toDate(), end_time.toDate(), '[1,2,5,8]', this.campaign.product.itemid, null)
      // for (const item of resp.data.data) {
      //   for (const key of Object.keys(item)) {
      //     if (metrics[key]) {
      //       metrics[key] += +item[key]
      //     } else {
      //       metrics[key] = +item[key]
      //     }
      //   }
      // }
      //
      // metrics.ctr = +(metrics.click / metrics.impression * 100).toFixed(2)
      // metrics.broad_cir = +metrics.broad_gmv ? +(+metrics.cost * 100 / +metrics.broad_gmv).toFixed(1) : 0
      // metrics.atosa_cpc = +metrics.click ? this.m__calculate(+metrics.cost / +metrics.click) : 0
      // metrics.cpm = +metrics.impression ? this.m__calculate(+metrics.cost / +metrics.impression * 1000) : 0
      // this.compare_metrics = metrics

      this.is_compare_keyword = true
      this.show_dialog.compare_keyword = false
      this.loading.compare_keyword = false
    },

    m__show_compare_keyword() {
      this.show_dialog.compare_keyword = true
    },

    async m__load_campaign_detail(is_reload = false) {
      // console.log(this.parent_campaign)

      try {
        const campaign = this.parent_campaign
        let response = this.is_full || is_reload
          ? await this.sp_user.marketing_get_campaign_detail(campaign.campaign.campaignid)
          : {data: campaign}

        if (!campaign.advertisements || !campaign.advertisements.length) {
          response = await this.sp_user.marketing_get_campaign_detail(campaign.campaign.campaignid)
        }

        // console.log(response)

        this.campaign = {
          ...response.data,
          product: campaign.product
        }
        this.campaign.product.itemid = this.campaign.advertisements[0].itemid
        this.advertisement_list = this.clone(_orderBy(this.campaign.advertisements, 'placement', 'asc'))

        const agg_type = this.campaign.advertisements.some(i => [1, 2, 5].includes(i.placement))
          ? 'display_location'
          : 'product_placement_auto_strategy'
        const start_time = this.dayjs(this.start_date).startOf('day')
        const end_time = this.dayjs(this.end_date).endOf('day')
        const new_response = await this.sp_user.marketing_get_report(agg_type, 'product', start_time.unix(), end_time.unix(), {campaign_id: campaign.campaign.campaignid})
        const report_response = this.m__map_targeting_report_by_key(new_response) || []
        // const report_response = await this.sp_user.target_marketing_get_report_v2(campaign.campaign.campaignid, campaign.product.itemid, this.dayjs(this.start_date).startOf('d').unix(), this.dayjs(this.end_date).endOf('d').unix())

        // todo: faster?
        this.parent_campaign.loading = false

        // const targeting_auto_campaign_response = await this.$http.get(this.API.URL_API_SRV_1 + '/targeting_auto_price/detail', {
        //   ...this.cf(),
        //   params: {
        //     mipeeUserId: this.$store.state.userInfo.username,
        //     campaignId: campaign.campaign.campaignid
        //   }
        // })
        const targeting_auto_position_response = await this.$http.get(this.API.URL_API_SRV_1 + '/targeting_auto_position/detail', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: campaign.campaign.campaignid
          }
        })
        const anti_click_response = await this.$http.get(this.API.URL_API_SRV_1 + '/targeting_anti_click/detail', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: campaign.campaign.campaignid
          }
        })
        // const auto_optimize_response = await this.$http.get(this.API.URL_API_SRV_1 + '/targeting_auto_optimize', {
        //   ...this.cf(),
        //   params: {
        //     mipeeUserId: this.$store.state.userInfo.username,
        //     campaignId: campaign.campaign.campaignid
        //   }
        // })

        for (const ads of response.data.advertisements) {
          ads.checked = false
          ads.keyword = `placement${ads.placement}`

          ads.extinfo.target.show_popover = false

          if (ads.extinfo && ads.extinfo.target && ads.extinfo.target.segments && ads.extinfo.target.segments.length) {
            ads.extinfo.target.price = _maxBy(ads.extinfo.target.segments, 'final_bid_price').final_bid_price
          }

          ads.auto_position = targeting_auto_position_response.body.find(i => i.placement === ads.placement)
          ads.anti_click = anti_click_response.body.find(i => i.placement === ads.placement)
          // ads.config_auto = targeting_auto_campaign_response.body.find(i => i.placement === ads.placement)
          // ads.auto_optimize = auto_optimize_response.body.find(i => i.placement === ads.placement)

          const report = report_response.find(i => i.placement === ads.placement.toString())
          if (report) {
            ads.report = this.m__map_detail_campaign_report(report)
          } else {
            ads.report = {...this.default_report}
          }

          const compare_report = this.compare_data.find(i => i.placement === ads.placement.toString())
          if (compare_report) {
            ads.c_report = this.m__map_detail_campaign_report(compare_report)
          } else {
            ads.c_report = {...this.default_report}
          }
        }

        this.recommended_list = []
        const recommended_response = await this.sp_user.marketing_pas_get_targeting_bid_price_data([this.parent_campaign.product.itemid])
        for (const ads of response.data.advertisements) {
          if (ads.placement === 2 && recommended_response && recommended_response.data && recommended_response.data.daily_discover) {
            ads.extinfo.target.recommended_price = this.m__calculate(recommended_response.data.daily_discover.recommended / 100000)
          }
          if (ads.placement === 5 && recommended_response && recommended_response.data && recommended_response.data.you_may_also_like) {
            ads.extinfo.target.recommended_price = this.m__calculate(recommended_response.data.you_may_also_like.recommended / 100000)
          }
        }

        // response.data.campaign.state = campaign.campaign.state
        this.campaign = {
          ...response.data,
          product: campaign.product
        }
        this.advertisement_list = this.clone(_orderBy(this.campaign.advertisements, 'placement', 'asc'))
        if (this.advertisement_list.length) {
          const found = this.advertisement_list.find(i => i.placement === 2)
          if (found) {
            this.base_price = found.extinfo.target.base_price
            this.ads_segments = found.extinfo.target.segments
          }
        }

        if (this.campaign.advertisements.some(i => [2, 5].includes(i.placement))) {
          this.show_target_audience = this.non_ads_data && this.non_ads_data.ext_toggle && this.non_ads_data.ext_toggle.sz_ads_product_target_audience
          this.m__get_campaign_target_audience(start_time, end_time)
            .catch(console.error)
        }

        await this.m__detail_report_by_time()

        this.sp_user.check_duplicate_ongoing_manual_product({
          campaign_id: this.c__campaign_id,
          item_id: this.parent_campaign.product.itemid
        })
          .then(response => {
            if (response && response.data && response.data.show_banner) {
              this.show_banner_duplicate = true
            }
          })
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('ads.error_with_getting_campaign_detail'))
      } finally {
        this.parent_campaign.loading = false
      }
    },

    async m__detail_report_by_time() {
      const start_time = this.dayjs(this.start_date).startOf('day').unix()
      const end_time = this.dayjs(this.end_date).endOf('day').unix()
      const response = await this.sp_user.marketing_get_time_graph('product', start_time, end_time, {campaign_id: this.c__campaign_id})
      if (response.data) {
        this.metrics = this.m__map_graph_response(response.data.report_aggregate)
        this.reports = this.m__map_graph_by_time_response(response.data.report_by_time)
      }

      // const metrics = {}
      //
      // const resp = await this.sp_user.marketing_detail_report_by_time_v2(this.c__campaign_id, this.start_date, this.end_date, '[1,2,5,8]', this.campaign.product.itemid, null)
      // for (const item of resp.data.data) {
      //   for (const key of Object.keys(item)) {
      //     if (metrics[key]) {
      //       metrics[key] += +item[key]
      //     } else {
      //       metrics[key] = +item[key]
      //     }
      //   }
      // }
      //
      // metrics.ctr = +(metrics.click / metrics.impression * 100).toFixed(2)
      // metrics.broad_cir = +metrics.broad_gmv ? +(+metrics.cost * 100 / +metrics.broad_gmv).toFixed(1) : 0
      // metrics.atosa_cpc = +metrics.click ? this.m__calculate(+metrics.cost / +metrics.click) : 0
      // metrics.cpm = +metrics.impression ? this.m__calculate(+metrics.cost / +metrics.impression * 1000) : 0
      // this.metrics = metrics
      // this.reports = resp.data.data
    },

    m__toggle_select_index() {
      if (!this.check_role(this.shop, 'targeting_ads', 'update_campaign')) {
        return
      }

      this.show_dialog.select_index = !this.show_dialog.select_index
    },

    m__is_show_index(value) {
      const flag = this.c__flag_list.find(i => i.value === value)
      if (flag) {
        return flag.checked
      } else {
        return false
      }
    },

    async m__get_flag_list() {
      const report_config_response = await this.sp_user.marketing_pas_get_report_config()
      if (report_config_response.data && report_config_response.data.selected_metric && report_config_response.data.selected_metric['product_manual']) {
        for (const flag of this.flag_list) {
          flag.checked = report_config_response.data.selected_metric['product_manual'].metric_list.includes(flag.value)
        }
      }
      if (!this.flag_list.some(i => i.checked)) {
        for (const flag of this.flag_list) {
          if (['impression', 'click', 'ctr', 'cost', 'broad_gmv'].includes(flag.value)) flag.checked = true
        }
      }
    },

    async m__update_flag_list() {
      if (this.flag_list.filter(i => i.checked === true).length <= 0) {
        return
      }
      const data = {
        metric_list: this.flag_list.reduce((r, i) => {
          if (i.checked) r.push(i.value)
          return r
        }, []),
        page: 'product_manual'
      }
      await this.sp_user.marketing_pas_update_metric_config(data)
    },

    m__calculate_price(ads) {
      return ads.extinfo.target.price
    },

    m__get_min_max(type) {
      if (!this.advertisement_list.length) {
        return
      }
      if (this.advertisement_list[0].placement === 8) {
        return
      }

      const found = this.advertisement_list.find(i => [2, 5].includes(i.placement))
      if (found) {
        if (type === 'min') {
          return _minBy(this.advertisement_list.filter(i => [2, 5].includes(i.placement)), 'extinfo.target.price').extinfo.target.price
        }
        if (type === 'max') {
          return _maxBy(this.advertisement_list.filter(i => [2, 5].includes(i.placement)), 'extinfo.target.price').extinfo.target.price
        }

        return 0
      }

      return 0
    },

    m__show_config_auto_campaign_multiple() {
    },

    m__show_update_multiple_keyword_price() {
    },

    m__show_update_multiple_keyword_match_type() {
    },

    m__remove_multiple_keyword() {
    },

    m__show_add_keywords_dialog() {
    },

    async m__handle_dropdown(command) {
      if (command === '1') {
        await this.m__export_shopee()
      }

      if (command === '4') {
        await this.m__export_metrics()
      }
    },

    async m__export_metrics() {
      const column_labels = this.$refs['main-table-detail'].columns.filter(i => i.property).map(i => i.label)
      column_labels.push(this.$t('base.date'))

      const data = []
      for (const keyword of this.advertisement_list.filter(i => [2, 5, 8].includes(i.placement)).reverse()) {
        const item = []
        for (const col of this.$refs['main-table-detail'].columns.filter(i => i.property)) {
          if (col.property === 'placement') {
            if (keyword[col.property] === 2) item.push(this.$t('base.daily_discover'))
            else if (keyword[col.property] === 5) item.push(this.$t('base.you_may_also_like'))
            else if (keyword[col.property] === 8) item.push(this.$t('ads.auto_bidding'))
            else item.push('')

            continue
          }

          item.push(this.get_value_by_path(keyword, col.property))
        }
        item.push(this.dayjs(this.start_date).startOf('d').format('DD/MM/YYYY'))
        data.push(item)
      }

      const filename = `report_${this.c__campaign_id}_${this.dayjs().format('DDMMYYYY')}.xlsx`
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        filename,
        data: [column_labels, ...data]
      }, {
        ...this.cf(),
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    async m__export_shopee() {
      this.loading.export_report = true
      const start_time = this.dayjs(this.start_date).startOf('d').unix()
      const end_time = this.dayjs(this.end_date).endOf('d').unix()

      const trigger_response = await this.sp_user.marketing_pas_report_trigger_or_get_previous({
        start_time,
        end_time,
        header: {},
        report_type: 'product_manual__single_detail',
        campaign_id: this.c__campaign_id
      })
      if (trigger_response && trigger_response.data && trigger_response.data.export_id) {
        const {export_id} = trigger_response.data

        let report_result = await this.sp_user.marketing_pas_report_get_single_result(export_id)
        while (report_result && report_result.data && ['waiting', 'processing'].includes(report_result.data.status)) {
          await this.sleep(1000)
          report_result = await this.sp_user.marketing_pas_report_get_single_result(export_id)
        }

        if (report_result && report_result.data && report_result.data.status === 'success') {
          const download_response = await this.sp_user.marketing_pas_report_download(export_id)
          const anchor = document.createElement('a')
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(download_response.data.content)
          anchor.target = '_blank'
          anchor.download = `${this.shop.username}.-${download_response.data.file_name}.csv`
          anchor.click()
        } else {
          this.ntf_w(this.$t('base.cannot_export_report'))
        }
      } else {
        this.ntf_w(this.$t('base.cannot_export_report'))
      }

      this.loading.export_report = false
    },

    async m__pause_campaign() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      this.campaign.campaign.state = 'paused'
      await this.sp_user.marketing_pas_update_campaign({
        campaign_id: this.c__campaign_id,
        header: {},
        type: 'pause'
      })
      this.$emit('change_state', 'paused')
    },

    async m__ongoing_campaign() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      this.campaign.campaign.state = 'ongoing'
      await this.sp_user.marketing_pas_update_campaign({
        campaign_id: this.c__campaign_id,
        header: {},
        type: 'resume'
      })
      this.$emit('change_state', 'ongoing')
    },

    async m__restart_campaign() {
      if (!this.check_role(this.shop, 'targeting_ads', 'update_campaign')) {
        return
      }

      this.campaign.campaign.state = 'ongoing'

      const form = {
        reference_id: make_uuid(),
        campaign: {
          campaign_id: this.c__campaign_id,
          daily_budget: +this.campaign.campaign.daily_quota * 100000,
          product_placement: 'targeting',
          target_audience: {
            target_audience_type: 'auto',
            group_list: []
          },
          bidding_strategy: 'manual',
          product_selection: 'manual',
          start_time: this.dayjs().startOf('day').unix(),
          end_time: 0
        },
        ads_list: [
          {
            item_id: this.campaign.product.itemid
          }
        ],
        header: {}
      }

      const placement2 = this.campaign.advertisements.find(i => [2, 5].includes(i.placement))
      if (placement2) {
        form.campaign.display_location = {
          daily_discover: {
            state: 'active',
            bid_price: this.TARGETING_MIN
          },
          you_may_also_like: {
            state: 'active',
            bid_price: this.TARGETING_MIN
          }
        }
        form.campaign.ecpc = true
        form.campaign.bidding_strategy = 'manual'

        const price = +placement2.extinfo.target.price && +placement2.extinfo.target.price > this.TARGETING_MIN ? +placement2.extinfo.target.price : this.TARGETING_MIN
        form.campaign.display_location.daily_discover.bid_price = price * 100000

        const placement5 = this.campaign.advertisements.find(i => i.placement === 5)
        if (placement5) {
          const price = +placement5.extinfo.target.price && +placement5.extinfo.target.price > this.TARGETING_MIN ? +placement5.extinfo.target.price : this.TARGETING_MIN
          form.campaign.display_location.you_may_also_like.bid_price = price * 100000
        }
      }

      const placement8 = this.campaign.advertisements.find(i => i.placement === 8)
      if (placement8) {
        form.campaign.bidding_strategy = 'auto'
        form.campaign.target_broad_roi = placement8.extinfo.target_broad_roi
      }

      const create_response = await this.sp_user.marketing_pas_publish_campaign(form)
      console.log(create_response)

      this.$emit('change_state', 'ongoing')
    },

    async m__stop_campaign() {
      if (!this.check_role(this.shop, 'targeting_ads', 'update_campaign')) {
        return
      }

      this.campaign.campaign.state = 'ended'
      await this.sp_user.marketing_pas_update_campaign({
        campaign_id: this.c__campaign_id,
        header: {},
        type: 'stop'
      })
      this.$emit('change_state', 'ended')
    },

    async m__delete_campaign() {
      if (!this.check_role(this.shop, 'keyword_ads', 'update_campaign')) {
        return
      }

      try {
        await this.$confirm(this.$t('base.delete_campaign_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.campaign.campaign.state = 'deleted'
      await this.sp_user.marketing_pas_update_campaign({
        campaign_id: this.c__campaign_id,
        header: {},
        type: 'delete'
      })
      this.$emit('change_state', 'deleted')
      this.ntf_s(this.$t('base.delete_success'))
    },

    m__show_update_base_price() {
      if (!this.check_role(this.shop, 'targeting_ads', 'update_campaign')) {
        return
      }

      this.show_dialog.update_keyword_price = true
    },

    m__show_update_premium_rate(ads) {
      if (!this.check_role(this.shop, 'targeting_ads', 'update_campaign')) {
        return
      }

      this.selected_ads = ads
      this.premium_rate = ads.extinfo.target.premium_rate
      this.show_dialog.update_premium_rate = true
    },

    m__show_update_keyword_price(ads) {
      this.selected_ads = ads
      this.selected_ads.extinfo.target.price = this.m__calculate(this.selected_ads.extinfo.target.price)
      this.show_dialog.update_keyword_price = true
    },

    async m__change_ads_status(ads) {
      if (!this.check_role(this.shop, 'targeting_ads', 'update_campaign')) {
        return
      }

      let placement = ''
      if (ads.placement === 2) placement = 'daily_discover'
      if (ads.placement === 5) placement = 'you_may_also_like'
      const body = {
        campaign_id: this.c__campaign_id,
        type: 'change_display_location',
        header: {},
        change_display_location: {
          bid_price: +ads.extinfo.target.price * 100000,
          place: placement,
          state: ads.status === 1 ? 'active' : 'inactive'
        }
      }

      await this.sp_user.marketing_pas_update_campaign(body)

      this.m__update_config_status('auto_position', 0, false, ads).catch(console.error)
      this.m__update_config_status('anti_click', 0, false, ads).catch(console.error)
    },

    async m__change_ads_status_placement8() {
      if (!this.check_role(this.shop, 'targeting_ads', 'update_campaign')) {
        return
      }

      if (this.advertisement_list.length > 1) {
        const placement8 = this.advertisement_list.find(i => i.placement === 8)
        if (placement8) {
          for (const i of this.advertisement_list) {
            if (i.placement !== 8) i.status = placement8.status === 1 ? 2 : 1
          }
        }
        await this.m__change_ads()
      } else {
        const placement8 = this.advertisement_list.find(i => i.placement === 8)
        if (placement8) {
          await this.sp_user.marketing_update_campaign({
            ads_audit_event: 6,
            campaign_ads_list: [{
              advertisements: [
                {
                  'itemid': this.campaign.product.itemid,
                  'placement': 2,
                  'campaignid': this.c__campaign_id,
                  'status': 1,
                  'extinfo': {
                    'target': {
                      'premium_rate': 0,
                      'base_price': this.TARGETING_MIN,
                      'price': this.TARGETING_MIN
                    }
                  }
                },
                {
                  'itemid': this.campaign.product.itemid,
                  'placement': 5,
                  'campaignid': this.c__campaign_id,
                  'status': 1,
                  'extinfo': {
                    'target': {
                      'premium_rate': 0,
                      'base_price': this.TARGETING_MIN,
                      'price': this.TARGETING_MIN
                    }
                  }
                },
                {
                  'placement': 8,
                  'adsid': placement8.adsid,
                  'campaignid': this.c__campaign_id,
                  'status': 2
                }
              ],
              campaign: this.campaign.campaign
            }]
          })
          await this.m__load_campaign_detail(false)
        }
      }
    },

    async m__update_ads_price() {
      const old_ads = this.clone(this.advertisement_list)

      if (!this.base_price) {
        this.ntf_w(this.$t('required.bid_price'))
        return
      }
      if (+this.base_price < this.TARGETING_MIN) {
        this.ntf_w(this.$t('base.y_gt_x', {
          y: this.$t('base.bid_price'),
          x: this.TARGETING_MIN
        }))
        return
      }

      this.loading.update_keyword_price = true

      const response = await this.sp_user.targeting_marketing_update_campaign_price(this.c__campaign_id, this.base_price)
      if (response && response.data && response.data.data && response.data.data.campaign_ads_list && response.data.data.campaign_ads_list.length) {
        for (const item of response.data.data.campaign_ads_list[0].advertisements) {
          const found = this.advertisement_list.find(i => i.placement === item.placement)
          if (found) Object.assign(found, item)
        }
      }
      const placement2 = this.advertisement_list.find(i => i.placement === 2)
      if (placement2) {
        placement2.extinfo.target.base_price = +this.base_price
        this.parent_campaign.base_price = +this.base_price
      }

      await this.m__save_update_price_log(old_ads, 'price')

      this.loading.update_keyword_price = false
      this.show_dialog.update_keyword_price = false
    },

    async m__change_ads() {
      const placement1 = this.campaign.advertisements.find(i => i.placement === 1)
      if (placement1) placement1.status = 2

      await this.sp_user.marketing_update_campaign({
        ads_audit_event: null,
        campaign_ads_list: [{
          advertisements: this.campaign.advertisements,
          campaign: this.campaign.campaign
        }]
      })

      this.$emit('sync_advertisements', this.campaign.advertisements)
    },

    m__show_config_auto_campaign(ads) {
      if (!this.check_role(this.shop, 'targeting_ads', 'auto_campaign')) {
        return
      }

      this.select_multiple = false
      this.selected_ads = ads

      if (ads.config_auto) {
        this.config_tab = 1

        this.form_config_auto_campaign = {
          placements: [ads.placement],
          times: ads.config_auto.times.map(i => {
            return {
              start_time: i.startTime,
              end_time: i.endTime
            }
          }),
          start_time: '',
          end_time: '',
          quota_type: ads.config_auto.quotaType,
          reduce_value: ads.config_auto.reduceValue,
          increase_value: ads.config_auto.increaseValue,
          state: ads.config_auto.state,
          not_exceed_2: ads.config_auto.notExceed2,
          not_exceed_2_value: ads.config_auto.notExceed2Value,
          not_exceed_3: ads.config_auto.notExceed3,
          not_exceed_3_value: ads.config_auto.notExceed3Value,
          not_exceed_4: ads.config_auto.notExceed4,
          not_exceed_4_value: ads.config_auto.notExceed4Value,
          not_exceed_5: ads.config_auto.notExceed5,
          not_exceed_5_value: ads.config_auto.notExceed5Value,
          not_exceed_6: ads.config_auto.notExceed6,
          not_exceed_6_value: ads.config_auto.notExceed6Value
        }
        this.form_config_auto_position.placements = [ads.placement]
      } else if (ads.auto_position) {
        this.config_tab = 2
        this.form_config_auto_position = {
          ...ads.auto_position,
          placements: [ads.placement],
          times: ads.auto_position.times.map(i => {
            return {
              start_time: i.startTime,
              end_time: i.endTime
            }
          }),
          stop_action: ads.auto_position.stopAction || 0,
          stop_action_2: ads.auto_position.stopAction2,
          stop_action_3: ads.auto_position.stopAction3
        }
        this.form_config_auto_campaign.placements = [ads.placement]
      } else {
        this.config_tab = 2
        this.form_config_auto_campaign = {
          placements: [ads.placement],
          times: [],
          start_time: '',
          end_time: '',
          quota_type: 1,
          reduce_value: 1,
          increase_value: 1,
          not_exceed_2: false,
          not_exceed_2_value: 0,
          not_exceed_3: false,
          not_exceed_3_value: 0,
          not_exceed_4: false,
          not_exceed_4_value: 0,
          not_exceed_5: false,
          not_exceed_5_value: 0,
          not_exceed_6: false,
          not_exceed_6_value: 0
        }

        this.form_config_auto_position = {
          keyword: '',
          urls: [],
          placements: [ads.placement],
          times: [],
          type: 1,
          fromValue: null,
          toValue: null,
          upValue: null,
          downValue: null,
          minValue: null,
          maxValue: null,
          minPrice: null,
          maxPrice: null,
          start_time: '',
          end_time: '',
          stop_action: 0,
          stop_action_2: null,
          stop_action_3: null,
          configStatus: 1,
        }
      }

      this.show_dialog.config_auto_campaign = true
    },

    async m__delete_config_auto_campaign() {
      if (!this.check_role(this.shop, 'targeting_ads', 'auto_campaign')) {
        return
      }

      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_auto_price', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: this.c__campaign_id,
            placement: this.selected_ads.placement
          }
        })
        this.ntf_s(this.$t('base.delete_success'))
        this.selected_ads.config_auto = null
        this.show_dialog.config_auto_campaign = false
      } catch (e) {
        console.error(e)
      }
    },

    async m__save_config_auto_campaign(state) {
      this.loading.config_auto_campaign = true

      try {
        if (!this.m__check_times(this.form_config_auto_campaign.times)) {
          this.ntf_w(this.$t('required.select_runtime'))
          return
        }

        const form = {
          placements: this.form_config_auto_campaign.placements,
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          shopId: this.shop._id,
          times: this.form_config_auto_campaign.times.map(i => {
            return {
              startTime: i.start_time,
              endTime: i.end_time
            }
          }),
          quotaType: this.form_config_auto_campaign.quota_type,
          reduceValue: this.form_config_auto_campaign.reduce_value,
          increaseValue: this.form_config_auto_campaign.increase_value,
          note: '',
          state: state,
          notExceed2: this.form_config_auto_campaign.not_exceed_2,
          notExceed2Value: this.form_config_auto_campaign.not_exceed_2_value,
          notExceed3: this.form_config_auto_campaign.not_exceed_3,
          notExceed3Value: this.form_config_auto_campaign.not_exceed_3_value,
          notExceed4: this.form_config_auto_campaign.not_exceed_4,
          notExceed4Value: this.form_config_auto_campaign.not_exceed_4_value,
          notExceed5: this.form_config_auto_campaign.not_exceed_5,
          notExceed5Value: this.form_config_auto_campaign.not_exceed_5_value,
          notExceed6: this.form_config_auto_campaign.not_exceed_6,
          notExceed6Value: this.form_config_auto_campaign.not_exceed_6_value
        }
        // await this.$http.post(this.API.URL_API_SRV_1 + '/auto_campaigns/v2', form)

        await this.$confirm(this.$t('ads.just_select_only_one_2'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })

        await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_auto_price', form, this.cf())

        for (const placement of this.form_config_auto_campaign.placements) {
          await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_auto_position', {
            ...this.cf(),
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: this.c__campaign_id,
              placement
            }
          })
        }

        this.$t('base.save_config_success')

        this.form_config_auto_campaign.state = state

        this.form_config_auto_campaign.placements.forEach(i => {
          const k = this.advertisement_list.find(kw => kw.placement === i)
          if (k) {
            k.config_auto = form
            k.auto_position = null
          }
        })
        this.show_dialog.config_auto_campaign = false
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.config_auto_campaign = false
      }
    },

    async m__save_config_auto_position() {
      this.loading.auto_position = true
      try {
        if (!this.m__check_times(this.form_config_auto_position.times)) {
          this.ntf_w(this.$t('required.select_runtime'))
          return
        }

        if (this.form_config_auto_position.type === 1 && (!this.form_config_auto_position.fromValue || !this.form_config_auto_position.toValue)) {
          this.ntf_w(this.$t('required.full_data'))
          return
        }

        if (this.form_config_auto_position.type === 2 && !this.form_config_auto_position.upValue) {
          this.ntf_w(this.$t('required.full_data'))
          return
        }

        if (this.form_config_auto_position.type === 3 && !this.form_config_auto_position.downValue) {
          this.ntf_w(this.$t('required.full_data'))
          return
        }

        if (!this.form_config_auto_position.maxValue) {
          this.ntf_w(this.$t('required.bonus_amount'))
          return
        }
        if (!this.form_config_auto_position.maxPrice) {
          this.ntf_w(this.$t('required.max_bid_price'))
          return
        }

        if (this.form_config_auto_position.stop_action === 2 && !this.form_config_auto_position.stop_action_2) {
          this.ntf_w(this.$t('required.percent_of_recommend_price'))
          return
        }

        if (this.form_config_auto_position.stop_action === 3 && !this.form_config_auto_position.stop_action_3) {
          this.ntf_w(this.$t('required.bid_price'))
          return
        }

        await this.$confirm(this.$t('ads.just_select_only_one_3'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })

        await this.$http.post(this.API.URL_API_SRV_1 + '/targeting_auto_position', {
          ...this.form_config_auto_position,
          mipeeUserId: this.$store.state.userInfo.username,
          campaignId: this.c__campaign_id,
          shopId: this.shop._id,
          times: this.form_config_auto_position.times.map(i => {
            i.startTime = i.start_time
            i.endTime = i.end_time
            return i
          }),
          stopAction: this.form_config_auto_position.stop_action,
          stopAction2: this.form_config_auto_position.stop_action_2,
          stopAction3: this.form_config_auto_position.stop_action_3,
        }, this.cf())

        for (const placement of this.form_config_auto_position.placements) {
          await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_auto_price', {
            ...this.cf(),
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: this.c__campaign_id,
              placement
            }
          })
        }

        for (const placement of this.form_config_auto_position.placements) {
          const found = this.advertisement_list.find(i => i.placement === placement)
          if (found) {
            found.config_auto = null
            found.auto_position = this.form_config_auto_position
          }
        }

        this.ntf_s(this.$t('base.save_config_success'))
        this.show_dialog.config_auto_campaign = false
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.auto_position = false
      }
    },

    async m__delete_config_auto_position_multiple() {
      if (!this.check_role(this.shop, 'targeting_ads', 'auto_campaign')) {
        return
      }

      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        for (const ads of this.c__advertisement_list.filter(i => i.checked)) {
          await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_auto_position', {
            ...this.cf(),
            params: {
              mipeeUserId: this.$store.state.userInfo.username,
              campaignId: this.c__campaign_id,
              placement: ads.placement
            }
          })
          ads.auto_position = null
        }
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
        console.error(e)
      }
    },

    async m__delete_config_auto_position() {
      if (!this.check_role(this.shop, 'targeting_ads', 'auto_campaign')) {
        return
      }

      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/targeting_auto_position', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            campaignId: this.c__campaign_id,
            placement: this.selected_ads.placement
          }
        })
        this.ntf_s(this.$t('base.delete_success'))
        this.selected_ads.auto_position = null
        this.show_dialog.config_auto_campaign = false
      } catch (e) {
        console.error(e)
      }
    },

    m__add_url() {
      if (this.form_config_auto_position.keyword && this.form_config_auto_position.urls.length < 3) {
        this.form_config_auto_position.urls.push(this.form_config_auto_position.keyword)
      }
      this.form_config_auto_position.keyword = ''
    },

    m__remove_url(index) {
      this.form_config_auto_position.urls.splice(index, 1)
    },

    m__show_update_campaign_date() {
      if (!this.check_role(this.shop, 'targeting_ads', 'update_campaign')) {
        return
      }

      if (this.campaign.campaign.state === 'ended' || this.campaign.campaign.state === 'closed') {
        return
      }

      if (this.campaign.campaign.end_time === 0) {
        this.selected_time_type = 'unlimited'
        this.campaign_time.start_time = new Date()
        // this.campaign_time.start_time = new Date(this.campaign.campaign.start_time * 1000)
      } else {
        this.selected_time_type = 'from_to'
        this.campaign_time.start_time = new Date()
        this.campaign_time.end_time = new Date(this.campaign.campaign.end_time * 1000)
      }
      this.show_dialog.update_campaign_date = true
    },

    m__show_update_campaign_quota() {
      if (!this.check_role(this.shop, 'targeting_ads', 'update_campaign')) {
        return
      }

      if (this.campaign.campaign.state === 'ended' || this.campaign.campaign.state === 'closed') {
        return
      }

      if (this.m__calculate(this.campaign.campaign.daily_quota) === 0 && this.m__calculate(this.campaign.campaign.total_quota) === 0) {
        this.selected_quota_type = '1'
      } else {
        this.selected_quota_type = '2'
        if (this.m__calculate(this.campaign.campaign.daily_quota) > 0) {
          this.campaign_quota.quota = this.m__calculate(this.campaign.campaign.daily_quota)
          this.campaign_quota.type = 'daily'
        } else {
          this.campaign_quota.quota = this.m__calculate(this.campaign.campaign.total_quota)
          this.campaign_quota.type = 'total'
        }
      }

      this.show_dialog.update_campaign_quota = true
    },

    async m__update_campaign_quota() {
      this.loading.update_campaign_quota = true

      const parent_campaign = this.parent_campaign.campaign
      const campaign = this.campaign.campaign
      const body = {
        campaign_id: campaign.campaignid,
        type: 'change_budget',
        change_budget: {
          daily_budget: 0,
          total_budget: 0,
          budget_log_key: 'budget_log_' + make_uuid()
        }
      }

      const log = {
        campaignId: campaign.campaignid,
        mipeeUserId: this.$store.state.userInfo.username,
        shopId: this.shop._id + '_single',
        oldDailyQuota: +campaign.daily_quota,
        oldCampaign: JSON.stringify(campaign),
        newDailyQuota: null,
        newCampaign: null
      }

      if (this.selected_quota_type === '1') {
        parent_campaign.daily_quota = campaign.daily_quota = body.change_budget.daily_budget = 0
        parent_campaign.total_quota = campaign.total_quota
      } else {
        if (this.campaign_quota.type === 'daily') {
          if (this.campaign_quota.quota < this.DAILY_BUDGET_MIN) {
            this.ntf_w(this.$t('base.y_gte_than_x', {
              y: this.$t('base.budget'),
              x: this.DAILY_BUDGET_MIN
            }))
            this.loading.update_campaign_quota = false
            return
          } else {
            parent_campaign.daily_quota = campaign.daily_quota = body.change_budget.daily_budget = this.campaign_quota.quota
            parent_campaign.total_quota = campaign.total_quota
          }
        }

        if (this.campaign_quota.type === 'total') {
          if (this.campaign_quota.quota < this.DAILY_BUDGET_MIN * 10) {
            this.ntf_w(this.$t('base.y_gte_than_x', {
              y: this.$t('base.budget'),
              x: this.DAILY_BUDGET_MIN * 10
            }))
            this.loading.update_campaign_quota = false
            return
          } else {
            parent_campaign.total_quota = campaign.total_quota
            parent_campaign.daily_quota = campaign.daily_quota = body.change_budget.daily_budget = 0
          }
        }
      }

      body.change_budget.daily_budget *= 100000
      await this.sp_user.marketing_pas_update_campaign(body, 'product')

      log.newDailyQuota = +campaign.daily_quota
      log.newCampaign = JSON.stringify(campaign)
      this.$http.post(this.API.URL_API_SRV_1 + '/lg/5.1', log, this.cf()).catch(console.error)

      this.ntf_s(this.$t('base.update_success'))

      this.loading.update_campaign_quota = false
      this.show_dialog.update_campaign_quota = false
    },

    async m__update_campaign_date() {
      this.loading.update_campaign_date = true

      if (this.selected_time_type === 'unlimited') {
        this.parent_campaign.campaign.end_time = this.campaign.campaign.end_time = 0
        await this.sp_user.marketing_pas_update_campaign({
          campaign_id: this.c__campaign_id,
          type: 'change_schedule',
          change_schedule: {
            start_time: this.campaign.campaign.start_time,
            end_time: 0
          }
        }, 'product')
      } else {
        if (!this.campaign_time.start_time) {
          this.ntf_w(this.$t('required.start_time'))
          return
        }
        if (!this.campaign_time.end_time) {
          this.$t('required.end_time')
          return
        }
        if (this.campaign_time.end_time.getTime() <= this.campaign_time.start_time.getTime()) {
          this.ntf_w(this.$t('base.y_gt_than_x', {
            y: this.$t('base.start_time'),
            x: this.$t('base.end_time'),
          }))
          return
        }

        this.parent_campaign.campaign.start_time = this.campaign.campaign.start_time = this.dayjs(this.campaign_time.start_time).startOf('d').unix()
        this.parent_campaign.campaign.end_time = this.campaign.campaign.end_time = this.dayjs(this.campaign_time.end_time).endOf('d').unix()
        await this.sp_user.marketing_pas_update_campaign({
          campaign_id: this.c__campaign_id,
          type: 'change_schedule',
          change_schedule: {
            start_time: this.campaign.campaign.start_time,
            end_time: this.campaign.campaign.end_time
          }
        }, 'product')
      }

      this.ntf_s(this.$t('base.update_success'))

      this.loading.update_campaign_date = false
      this.show_dialog.update_campaign_date = false
    }
  }
}
</script>

<style lang="scss">
.segment-cluster {
  cursor: pointer;

  .el-icon-edit {
    display: none;
  }
}

.segment-cluster:hover {
  .el-icon-edit {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pas/detail/targeting.vue